// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-21T22:01:00.437Z
// Property: Woodgate (ID: 6767906449166460)
// Collections: 23 amenities, 9 floorplans (live), 24 photos, 49 POIs, 2 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166460",
  "property_external_id": "pz33jpv",
  "property_zillow_url": "https://www.zillow.com/apartments/west-jordan-ut/woodgate/FMtk/",
  "property_apartments_url": "https://www.apartments.com/woodgate-at-jordan-landing-west-jordan-ut/pz33jpv/",
  "property_google_business_url": "https://www.google.com/maps/place/Woodgate+Apartments+at+Jordan+Landing/data=!4m2!3m1!1s0x0:0xb0563ee82d86003f?sa=X&ved=2ahUKEwj34NLN5aeSAxUezTgGHaSHCqQQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40256880237",
  "property_crm_software": null,
  "property_pm_software": "AIM",
  "property_pm_info": "628WJL",
  "property_status": null,
  "property_slug": "woodgate",
  "property_name": "Woodgate",
  "property_website_url": "http://www.woodgateapts.net",
  "property_domain": "https://www.woodgateapts.net/",
  "property_address": "3851 South Cobble Ridge Drive",
  "property_full_address": "3851 S Cobble Ridge Dr, West Jordan, UT 84084",
  "property_address_1": "3851 S Cobble Ridge Dr",
  "property_address_2": null,
  "property_address_city": "West Jordan",
  "property_address_state": "UT",
  "property_address_zip_full": null,
  "property_address_zip": "84084",
  "property_address_country": "US",
  "property_address_county": "Salt Lake County",
  "property_neighborhood_address": "Dixie Valley",
  "property_address_latitude": "40.6232027",
  "property_address_longitude": "-111.983176",
  "property_email": null,
  "property_phone": "(844) 201-7843",
  "property_call_tracking_phone": "844-201-7843",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Woodgate in West Jordan, UT, your ideal apartment awaits! Choose from spacious one, two, or three-bedroom layouts, complete with stylish finishes and modern amenities. Relax by the pool, get fit in our gym, or unwind in the dog park. Your vibrant community lifestyle begins here—come see for yourself!",
  "property_long_description": "Welcome to Woodgate, the premier apartment community in the heart of West Jordan, UT, where comfort meets convenience. Our thoughtfully designed floor plans offer a variety of options, including one, two, and three-bedroom apartments, each tailored to fit your lifestyle. Experience resort-style living with an impressive array of amenities that include a sparkling pool, state-of-the-art fitness center, and a welcoming clubhouse perfect for social gatherings.\n\nFamilies will appreciate our safe and engaging playground, while pet lovers can take advantage of the expansive dog park and pet play area. Enjoy the outdoors with our sundeck and picnic area, or unwind in the relaxing spa. For those who work from home or need to stay connected, we offer high-speed internet access and online services for effortless convenience.\n\nAt Woodgate, you'll also find controlled access to enhance your security, along with maintenance and package services right at your fingertips. Our apartments boast luxury features such as granite and quartz countertops, hardwood floors, and spacious walk-in closets, making your living space both stylish and functional.\n\nWith easy access to public transportation, Woodgate is perfectly situated for both leisure and commuting. Explore the community’s planned social activities, basketball court, and extensive storage options to fit your needs.\n\nFind your new home today—browse our availability or schedule a tour to visit Woodgate and discover why our residents love living here! Come experience the lifestyle you deserve at Woodgate, where modern living meets a vibrant community.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02d0-069f-77fe-ae91-2744950349dd.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a suburban apartment complex with multiple buildings, manicured lawns, and trees.",
    "public_id": "019d02d0-069f-77fe-ae91-2744950349dd",
    "storage_key": "property/6767906449166460/019d02d0-069f-77fe-ae91-2744950349dd.webp",
    "width": 1024,
    "height": 576
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166460/019f66a5-235b-7293-82ee-90daceaaf344.m4v",
  "property_featured_video_media": {
    "public_id": "019f66a5-235b-7293-82ee-90daceaaf344",
    "storage_key": "property/6767906449166460/019f66a5-235b-7293-82ee-90daceaaf344.m4v",
    "thumbnail_key": "property/6767906449166460/019f66a5-235b-7293-82ee-90daceaaf344_thumb.webp",
    "size_bytes": 27474704,
    "classification": "Community",
    "title": "Woodgate Hero Video",
    "description": "Imported from Duda homepage hero background video"
  },
  "property_total_units": "288",
  "property_year_built": "2001",
  "property_year_renovated": null,
  "property_walk_score": "45",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.48611111111111",
  "property_admin_fee": "399",
  "property_application_fee": "65",
  "property_fees_deposit_info": "Security Deposit\n$200-1 Month's Rent (OAC)\n(refundable)",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "150",
  "property_monthly_pet_rent": "60",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "45",
  "property_pet_restrictions": "We welcome dogs and cats (breed restrictions apply). Dog weight limit: 45 lb.",
  "property_pet_policy_description": "We welcome dogs and cats (breed restrictions apply). Dog weight limit: 45 lb. Pet fee: $300–$600. Pet deposit: $100–$200. Monthly pet rent: $60 per pet. Maximum 2 pets per unit.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://woodgate.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.myrentalapplication.com/index/amcwoodgate",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02d1-3571-77fd-bfa6-1b4dbb061ab1.webp",
  "property_primary_logo_media": {
    "alt_text": "Woodgate at Jordan Landing logo",
    "public_id": "019d02d1-3571-77fd-bfa6-1b4dbb061ab1",
    "storage_key": "property/6767906449166460/019d02d1-3571-77fd-bfa6-1b4dbb061ab1.webp",
    "width": 458,
    "height": 150
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02d1-298a-70ef-9700-53863aa3aefc.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02d1-298a-70ef-9700-53863aa3aefc",
    "storage_key": "property/6767906449166460/019d02d1-298a-70ef-9700-53863aa3aefc.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02d1-51e3-71ff-858c-d783e9ac0097.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Woodgate at Jordan Landing logo.",
    "public_id": "019d02d1-51e3-71ff-858c-d783e9ac0097",
    "storage_key": "property/6767906449166460/019d02d1-51e3-71ff-858c-d783e9ac0097.webp",
    "width": 458,
    "height": 150
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02d1-5b7e-73ac-9a65-511260218cc3.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Woodgate at Jordan Landing logo.",
    "public_id": "019d02d1-5b7e-73ac-9a65-511260218cc3",
    "storage_key": "property/6767906449166460/019d02d1-5b7e-73ac-9a65-511260218cc3.webp",
    "width": 458,
    "height": 150
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "640 - 1033",
  "property_sqft_min": "640",
  "property_sqft_max": "1033",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 13,
  "property_facebook_url": "https://www.facebook.com/aptswoodgate/",
  "property_instagram_url": "https://www.instagram.com/woodgate.jordan.landing/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJpyXRU5GOUocRPwCGLeg-VrA",
  "property_youtube_url": "https://www.youtube.com/watch?t=103&v=Ak6C6HhvZe8",
  "property_yelp_url": "https://m.yelp.com/search?find_desc=cheap+apartments+for+rent&find_loc=South+Jordan%2C+UT",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Woodgate",
  "property_home_romance_title": "Embrace the Comfort of Your New Community Home",
  "property_home_amenities_blurb": "Welcome to Woodgate in West Jordan, UT, where comfort meets convenience. Choose from thoughtfully designed one, two, or three-bedroom floor plans, all equipped with modern amenities. Enjoy relaxing by the pool, staying active in the fitness center, or unwinding in the dog park. Your ideal home awaits!",
  "property_home_floorplans_blurb": "At Woodgate in West Jordan, UT, your ideal living space awaits! Choose from our thoughtfully designed one, two, or three-bedroom floor plans, each crafted for comfort and style. Browse our available apartment homes today and step into a lifestyle that perfectly fits your vision of home.",
  "property_home_gallery_blurb": "Welcome to Woodgate in West Jordan, UT, where comfort meets style! Choose from spacious one, two, or three-bedroom apartments, featuring luxurious granite countertops and modern stainless steel appliances. Enjoy amenities like a refreshing pool, fitness center, and vibrant playground. Picture yourself living here, where every day feels like a getaway!",
  "property_home_neighborhood_blurb": "At Woodgate in West Jordan, adventure awaits just beyond your doorstep. Enjoy quick access to outdoor recreation, fitness hubs like EōS Fitness and VASA Fitness, as well as family-friendly attractions such as Altitude Trampoline Park and the Maverik Center. Immerse yourself in a vibrant community where convenience meets excitement.",
  "property_home_reviews_blurb": "At Woodgate Apartments in West Jordan, UT, community means everything. Our residents rave about our \"wonderful management\" and how they consistently “get to know us by name.” With serene surroundings, a dog park, and top-notch amenities, it’s clear why so many consider Woodgate their cherished home. Join us today!",
  "property_neighborhood_blurb": "Nestled in West Jordan, Woodgate offers not just stylish one, two, and three-bedroom apartments, but also a vibrant lifestyle. Enjoy nearby attractions like the Utah Olympic Oval, Maverik Center, and EōS Fitness. From parks to shopping at Fashion Place, your ideal living experience awaits. Check out our community’s local gems!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Woodgate in West Jordan, UT, comfort meets convenience. Choose from spacious one to three-bedroom floor plans, and enjoy resort-style amenities like a sparkling pool, fitness center, and dog park. With features such as granite countertops and high-speed internet, your ideal home awaits – a place to unwind, socialize, and thrive.",
  "property_applynow_blurb": "At Woodgate in West Jordan, UT, choose from spacious one, two, or three-bedroom apartments designed for comfort and convenience. Enjoy resort-style amenities like a sparkling pool, fitness center, and cozy lounge. With pet-friendly spaces and vibrant social activities, your ideal home awaits. Secure your spot and lease online today!",
  "property_contactus_blurb": "At Woodgate in West Jordan, UT, our thoughtfully designed floor plans include one, two, and three-bedroom options tailored to suit your lifestyle. Experience comfort and community in a welcoming environment. Have questions? Contact our leasing team today for personalized assistance and to find your perfect home!",
  "property_faqs_blurb": "At Woodgate in West Jordan, UT, your dream home awaits! Whether you prefer the cozy charm of a one-bedroom or the spacious comfort of a three-bedroom apartment, we have a perfect floor plan for everyone. Curious about our community? Visit our FAQs page for all the answers!",
  "property_floorplans_blurb": "At Woodgate in West Jordan, UT, our thoughtfully designed floor plans cater to every lifestyle. Choose from cozy one-bedroom retreats, spacious two-bedroom havens, or luxurious three-bedroom spaces, each tailored for comfort and style. Browse our available apartment homes today to find the perfect fit for your next chapter.",
  "property_gallery_blurb": "At Woodgate in West Jordan, UT, our vibrant community invites you to envision a life enhanced by resort-style amenities. From relaxing by the pool to enjoying a picnic with friends in our lush courtyard, every moment feels like a getaway. Picture yourself living here, surrounded by comfort and convenience!",
  "property_interactivemap_blurb": "Nestled in the heart of West Jordan, Woodgate offers a vibrant community with one, two, and three-bedroom apartments designed for modern living. Enjoy fantastic amenities including a sparkling pool, fitness center, and pet-friendly spaces. Utilize our interactive community map to find your perfect home and see pricing today!",
  "property_pets_blurb": "At Woodgate in West Jordan, UT, your furry friends are part of the family! With ample green spaces and a welcoming community, we invite you and your pets to thrive together. Enjoy life with your dogs and cats while adhering to our reasonable breed restrictions and pet policies.",
  "property_referafriend_blurb": "At Woodgate in West Jordan, UT, our spacious one, two, and three-bedroom floor plans offer the perfect blend of comfort and style. Great friends make great neighbors, so refer a friend to join our vibrant community today! Together, you’ll create unforgettable memories in your new home.",
  "property_residentaccess_blurb": "At Woodgate in West Jordan, UT, your ideal home awaits with spacious one, two, and three-bedroom floor plans tailored for your lifestyle. Access our resident portal to effortlessly pay rent, schedule maintenance, and engage with your community. Your convenience is just a click away—welcome to worry-free living!",
  "property_reviews_blurb": "At Woodgate Apartments in West Jordan, residents rave, \"The staff is super nice and helpful,\" making it a community where everyone feels at home. Enjoy beautiful grounds, pet-friendly amenities, and a prime location near Jordan Landing. Experience the warmth and service that turn a residence into a cherished home!",
  "property_created_at": "1759782607560",
  "property_scheduletour_blurb": "At Woodgate in West Jordan, UT, our spacious floor plans cater to every lifestyle, offering one, two, and three-bedroom options designed for comfort and convenience. Schedule a tour today to experience our vibrant community and hear firsthand from residents about their amazing living experience!",
  "property_thankyou_blurb": "Thank you for reaching out to Woodgate in West Jordan, UT! Our diverse floor plans—ranging from cozy one-bedroom to spacious three-bedroom apartments—cater to all lifestyles. Expect a team member to connect with you soon to help you find your perfect home!",
  "property_virtualtours_blurb": "Step inside Woodgate, the premier apartment community in West Jordan, UT, where comfort meets style. Choose from our thoughtfully designed one, two, and three-bedroom floor plans to find your perfect fit. Experience the charm of our community—take a virtual tour today and envision your new home!",
  "property_copyright": "2025 All Rights Reserved. Woodgate",
  "property_seo_title_home": "Apartments in Jordan, UT | Woodgate at Jordan Landing",
  "property_seo_description_home": "Woodgate at Jordan Landing is a modern apartment living community with pet-friendly 1, 2, & 3-Bedroom apts for rent in Jordan, UT. Contact us today!",
  "property_seo_title_floorplans": "Floor Plans | 1, 2, & 3 Bedroom Apartments in Jordan, UT",
  "property_seo_description_floorplans": "Explore spacious 1, 2, & 3-Bedroom apts at Woodgate at Jordan Landing in Jordan, UT. A renovated clubhouse, gas grills and a fitness center awaits.",
  "property_seo_title_amenities": "Amenities | Jordan, UT Apartments With a Gated Paw Park",
  "property_seo_description_amenities": "Enjoy soaring vaulted ceilings and valet trash service at Woodgate at Jordan Landing in Jordan, UT. Pet-friendly living made easy.",
  "property_seo_title_gallery": "Gallery | Modern Apartments For Rent in Jordan, UT",
  "property_seo_description_gallery": "View photos of Woodgate at Jordan Landing in Jordan, Utah. See stylish floor plans, modern amenities, and pet-friendly community spaces.",
  "property_seo_title_virtualtours": "Virtual Tour | Pet-Friendly Apartments in Jordan, UT",
  "property_seo_description_virtualtours": "Embark on a virtual journey at Woodgate at Jordan Landing! Explore our pet-friendly 1, 2, & 3-Bedroom apts in Jordan, UT, through our virtual tours.",
  "property_seo_title_interactivemap": "Interactive Map | Apartments For Rent in Jordan, UT",
  "property_seo_description_interactivemap": "Find your perfect home at Woodgate in West Jordan, UT! Use our interactive map to browse floor plans, view amenities, and discover your dream apartment today.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments Near Skyview Basin Park",
  "property_seo_description_neighborhood": "Live close to Skyview Basin Park and Jordan Landing Shopping Centerat Woodgate at Jordan Landing with apts designed for your comfort and convenience.",
  "property_seo_title_contact": "Contact Us | Apartments With Fireplaces For Rent",
  "property_seo_description_contact": "Contact Woodgate at Jordan Landing today to schedule a tour. Discover 1, 2, & 3-Bedroom apartments with modern features in Jordan, UT.",
  "property_seo_title_faqs": "FAQs | Apartments in West Jordan, UT",
  "property_seo_description_faqs": "Find answers to your inquiries about Woodgate in West Jordan, UT. Explore FAQs on our amenities, floor plans, and vibrant community life today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in West Jordan, UT",
  "property_seo_description_reviews": "Join the Woodgate community in West Jordan, UT! Discover resident reviews and top amenities like pools, fitness centers, and pet areas.",
  "property_seo_title_applynow": "Apply Now | 3 Bedroom Apartments in Jordan, UT",
  "property_seo_description_applynow": "Ready to make Woodgate at Jordan Landing your new home? Apply online for our 1, 2, & 3-Bedroom apts in Jordan near local parks and start your journey today!",
  "property_seo_title_residentaccess": "Resident Access | Modern Jordan, UT One Bedroom Units",
  "property_seo_description_residentaccess": "At Woodgate at Jordan Landing, our resident portal offers seamless 24/7 access, simplifying maintenance requests and online rent payments for your convenience.",
  "property_seo_title_referafriend": "Refer A Friend | Woodgate",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Woodgate in West Jordan, UT, and share the joy of our vibrant community. Start your referral today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Apartments With a Relaxing Swimming Pool",
  "property_seo_description_scheduletour": "Excited to explore Woodgate at Jordan Landing in person? Arrange a tour to discover our amenities and open-concept apartments designs in Jordan, UT!",
  "property_seo_title_privacy": "Privacy Policy | Woodgate",
  "property_seo_description_privacy": "At Woodgate in West Jordan, UT, your privacy matters. Dive into our commitment to safeguarding your data. View our comprehensive privacy policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Woodgate",
  "property_seo_description_accessibility": "At Woodgate in West Jordan, UT, we prioritize accessibility and digital inclusion. Experience a community that embraces everyone—join us today!",
  "property_seo_title_sitemap": "Sitemap | Woodgate",
  "property_seo_description_sitemap": "Navigate your way to Woodgate in West Jordan, UT! Check out our sitemap for a seamless journey through our vibrant community and amenities.",
  "property_seo_title_thankyou": "Thank You | Lease Woodgate at Jordan Landing Apts in Jordan",
  "property_seo_description_thankyou": "Thank you for your interest in Woodgate at Jordan Landing. We will process your request and get back to you shortly!",
  "property_seo_title_pets": "Pet Policy | 1 Bedroom Apartments in Jordan, UT",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1784736313553",
  "amenities": [
    {
      "id": "custom_b6e4cb90-ff93-4196-bffc-2163f3938c85",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Year Round Open Air Spa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_70eccbd1-2fd1-4bc0-8f19-12df7253cb21",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Amazon Parcel Lockers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_d3261328-2ccc-45f0-8cec-677c2a64ad8c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Paw Park and Play Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e58c5595-13f4-4d7a-92ca-d8fed2f81b79",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Two Relaxing Swimming Pool with Fire Pit & Lounge Seating",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_0c57d608-5c47-4776-99b2-9866572b2a91",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Activity Area with Playground and Basketball",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a6c34ce6-215c-479a-8c7d-ac57b1398e16",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Valet Trash Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e29af8bb-7937-4060-85ba-86624b3ed08d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Garages Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_30eea783-2b95-44ad-b3de-11f5df33e31f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Conveniently Located Next to Jordan Landing Shopping Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_221aa232-0b6e-4ed5-8138-eb7018a3ae28",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Newly Renovated Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ae558cf1-76e0-42d9-97c5-449436791b32",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "State of the Art Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_40e2e123-69f4-404e-b6ea-32aa5c40d141",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Nest Smart Thermostats",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_9783505a-91f0-4d05-85dc-078e6f7cac98",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Beautifully Renovated Apartments*",
      "amount": "false",
      "description": "Select units only",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_1d0ce838-fa32-4b1e-aa94-559a8a664283",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Modern Quartz Counter Tops *",
      "amount": "false",
      "description": "Select units only",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_b9f02df0-94b3-40a4-a072-23bf3644b56b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Complete Stainless Steel Appliance Package*",
      "amount": "false",
      "description": "Select units only",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_3d48b674-0dd8-44d9-b717-65a6dae27433",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Contemporary Tile Backsplash*",
      "amount": "false",
      "description": "Select units only",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4d1273b7-5071-4f32-9b83-d060bfeaa8fc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Wood-Style Plank Flooring*",
      "amount": "false",
      "description": "Select units only",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_60c5ca56-36e6-4c66-88e4-6e307a8652bc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Personal Balconies/Patios",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_41a7e9f3-11ed-435b-a1ce-329b4e0662cf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Full Size Washers and Dryers",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_d4deeb73-874e-48d8-91cb-589f34242829",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient USB Wall Outlets*",
      "amount": "false",
      "description": "Select units only",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4abf3565-93bc-4302-9a2f-af525ebe4e2a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Soaring Vaulted Ceilings *",
      "amount": "false",
      "description": "Select units only",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_10039030-5a5e-4353-aca5-0176880b3076",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Walk In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_735fc3e4-9269-4edb-800b-5c97b3e4150f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplaces*",
      "amount": "false",
      "description": "Select units only",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_656bc951-6658-430a-bb54-fc8f2aa5b0b2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "external_id": "false",
      "title": "Reserved Covered Parking",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_8be3a7d2-2508-4c9f-bfef-c0e0bc7abf14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-21fb-73e9-8c44-cc4353d90352.webp",
      "image_media": {
        "alt_text": "Woodgate at Jordan Landing monument sign with address 3851.",
        "public_id": "019f66ac-21fb-73e9-8c44-cc4353d90352",
        "storage_key": "property/6767906449166460/019f66ac-21fb-73e9-8c44-cc4353d90352.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to Woodgate at Jordan Landing, a premier apartment community. This monument sign, displaying the property name and address, marks the entrance to our beautiful grounds.",
      "link": "",
      "alt_text": "Woodgate at Jordan Landing monument sign with address 3851.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC6578.jpg"
    },
    {
      "id": "custom_3000f697-2190-4733-9eb8-75383a4d377f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-21fb-73e9-8c44-d2d9ac0ff7a0.webp",
      "image_media": {
        "alt_text": "Building entrance with colorful flower beds and lush green lawn at Woodgate in West Jordan, UT.",
        "public_id": "019f66ac-21fb-73e9-8c44-d2d9ac0ff7a0",
        "storage_key": "property/6767906449166460/019f66ac-21fb-73e9-8c44-d2d9ac0ff7a0.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Welcome to our community's leasing office, featuring a beautifully landscaped entrance with vibrant flowers and well-maintained greenery.",
      "link": "",
      "alt_text": "Building entrance with colorful flower beds and lush green lawn at Woodgate in West Jordan, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC6553.jpg"
    },
    {
      "id": "custom_f71322b3-1c9c-4b69-8c53-4819bad509e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-23b6-75fe-b12c-0b61862d0b72.webp",
      "image_media": {
        "alt_text": "Aerial view of an apartment complex with lush green landscaping and mountains in the background at Woodgate in West Jordan, UT.",
        "public_id": "019f66ac-23b6-75fe-b12c-0b61862d0b72",
        "storage_key": "property/6767906449166460/019f66ac-23b6-75fe-b12c-0b61862d0b72.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Discover beautiful apartment living with stunning mountain views and well-maintained grounds. Experience comfort and convenience in our vibrant community.",
      "link": "",
      "alt_text": "Aerial view of an apartment complex with lush green landscaping and mountains in the background at Woodgate in West Jordan, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/1.png"
    },
    {
      "id": "custom_705e6bf3-95cc-4f82-bc4e-9c4e41326742",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-223c-719e-b45e-17d5ee0099d2.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with comfortable seating, bar stools, and modern decor at Woodgate in West Jordan, UT.",
        "public_id": "019f66ac-223c-719e-b45e-17d5ee0099d2",
        "storage_key": "property/6767906449166460/019f66ac-223c-719e-b45e-17d5ee0099d2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Stylish lounge area with comfortable seating, bar stools, and modern decor at Woodgate in West Jordan, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC5398.jpg"
    },
    {
      "id": "custom_99e5cc99-82f4-44d9-b411-6f0b1d510cb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-218b-779f-94ed-f2c651912bcd.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, and stationary bikes.",
        "public_id": "019f66ac-218b-779f-94ed-f2c651912bcd",
        "storage_key": "property/6767906449166460/019f66ac-218b-779f-94ed-f2c651912bcd.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, fully equipped with cardio machines to help you reach your health goals.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, and stationary bikes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/5742705921490944/6767906449166460/a72c89c2869b388b05876dd24ab3ea97.jpg"
    },
    {
      "id": "custom_6654b537-28e0-42e8-a88a-035c788c53ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-2237-707c-bf56-3c5f7fbc0b7d.webp",
      "image_media": {
        "alt_text": "Fitness center with weights, medicine balls, yoga mats, and mirrors at Woodgate in West Jordan, UT.",
        "public_id": "019f66ac-2237-707c-bf56-3c5f7fbc0b7d",
        "storage_key": "property/6767906449166460/019f66ac-2237-707c-bf56-3c5f7fbc0b7d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, free weights, medicine balls, and yoga mats.",
      "link": "",
      "alt_text": "Fitness center with weights, medicine balls, yoga mats, and mirrors at Woodgate in West Jordan, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC5548.jpg"
    },
    {
      "id": "custom_014640fb-8ff3-4c6e-b5ff-9e2dee19f658",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-3384-702e-b64a-0614d0f8f0d8.webp",
      "image_media": {
        "alt_text": "Gym with dumbbells, weight machines, and motivational wall art at Woodgate in West Jordan, UT.",
        "public_id": "019f66ac-3384-702e-b64a-0614d0f8f0d8",
        "storage_key": "property/6767906449166460/019f66ac-3384-702e-b64a-0614d0f8f0d8.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is fully equipped with a variety of weight machines and free weights to help you achieve your fitness goals. Stay motivated with inspiring wall art.",
      "link": "",
      "alt_text": "Gym with dumbbells, weight machines, and motivational wall art at Woodgate in West Jordan, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC5538.jpg"
    },
    {
      "id": "custom_3330b40f-458a-4eb9-9d93-33e483bb6e62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-21fc-7759-9c8c-8b81d0121428.webp",
      "image_media": {
        "alt_text": "Treadmills and weight machines in a well-lit fitness center with large mirrors.",
        "public_id": "019f66ac-21fc-7759-9c8c-8b81d0121428",
        "storage_key": "property/6767906449166460/019f66ac-21fc-7759-9c8c-8b81d0121428.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Treadmills and weight machines in a well-lit fitness center with large mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC5543.jpg"
    },
    {
      "id": "custom_deba33cf-f630-41c9-881c-2bf7062903e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-30e5-755f-9366-6c7f46aca773.webp",
      "image_media": {
        "alt_text": "Luxury apartment complex with a large outdoor swimming pool, lounge chairs, umbrellas, and seating areas.",
        "public_id": "019f66ac-30e5-755f-9366-6c7f46aca773",
        "storage_key": "property/6767906449166460/019f66ac-30e5-755f-9366-6c7f46aca773.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded seating areas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Luxury apartment complex with a large outdoor swimming pool, lounge chairs, umbrellas, and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/DJI_20251006122448_0946_D_0000.jpg"
    },
    {
      "id": "custom_c118a5b2-7b7a-4ee3-8b02-6a94aab91473",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-2ec2-7733-8e62-971130af1185.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Woodgate in West Jordan, UT.",
        "public_id": "019f66ac-2ec2-7733-8e62-971130af1185",
        "storage_key": "property/6767906449166460/019f66ac-2ec2-7733-8e62-971130af1185.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and umbrellas for your enjoyment.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Woodgate in West Jordan, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC5503.jpg"
    },
    {
      "id": "custom_3fd9bc2b-8e81-4c9e-a11d-f08d44651baf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-305d-735c-958c-bac55fff3a97.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Woodgate in West Jordan, UT.",
        "public_id": "019f66ac-305d-735c-958c-bac55fff3a97",
        "storage_key": "property/6767906449166460/019f66ac-305d-735c-958c-bac55fff3a97.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Woodgate in West Jordan, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC5518.jpg"
    },
    {
      "id": "custom_85f0bf63-a467-48ff-a792-18e8505022b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-30d0-7086-9923-6490820522b1.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with tables and blue umbrellas.",
        "public_id": "019f66ac-30d0-7086-9923-6490820522b1",
        "storage_key": "property/6767906449166460/019f66ac-30d0-7086-9923-6490820522b1.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable seating and shaded areas for a perfect day.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with tables and blue umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC6513.jpg"
    },
    {
      "id": "custom_b509da66-effe-4282-89c5-91ecef5b2acd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-3126-7169-ae29-423497f1f6e5.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs, umbrellas, and seating areas.",
        "public_id": "019f66ac-3126-7169-ae29-423497f1f6e5",
        "storage_key": "property/6767906449166460/019f66ac-3126-7169-ae29-423497f1f6e5.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning outdoor swimming pool, complete with comfortable lounge chairs, shaded umbrellas, and inviting seating areas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs, umbrellas, and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC5533.jpg"
    },
    {
      "id": "custom_c473bc98-ff56-4c05-af44-2f8b4e217073",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-3312-704c-af58-4ee1d72ac410.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with built-in grills and blue umbrellas next to a swimming pool.",
        "public_id": "019f66ac-3312-704c-af58-4ee1d72ac410",
        "storage_key": "property/6767906449166460/019f66ac-3312-704c-af58-4ee1d72ac410.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy al fresco dining with our state-of-the-art outdoor kitchen, featuring multiple grills and comfortable seating areas perfect for entertaining.",
      "link": "",
      "alt_text": "Outdoor kitchen with built-in grills and blue umbrellas next to a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/5742705921490944/6767906449166460/9c3a72d906a5d24895691a8a3606139a.jpg"
    },
    {
      "id": "custom_ade2898b-7bb7-490d-8306-3cca5412671c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-33c7-7637-944e-05ef19823ade.webp",
      "image_media": {
        "alt_text": "Playground equipment with slides and climbing structures.",
        "public_id": "019f66ac-33c7-7637-944e-05ef19823ade",
        "storage_key": "property/6767906449166460/019f66ac-33c7-7637-944e-05ef19823ade.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring slides and climbing structures for endless entertainment.",
      "link": "",
      "alt_text": "Playground equipment with slides and climbing structures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/DJI_20251006122550_0947_D_0000.jpg"
    },
    {
      "id": "custom_19cfa392-3593-4fa9-ac90-32fa174feb3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-406c-7348-8d70-292bc4325fb4.webp",
      "image_media": {
        "alt_text": "Parcel locker with a mountain landscape wrap at Woodgate in West Jordan, UT.",
        "public_id": "019f66ac-406c-7348-8d70-292bc4325fb4",
        "storage_key": "property/6767906449166460/019f66ac-406c-7348-8d70-292bc4325fb4.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Other",
      "description": "Conveniently receive packages with our secure, on-site parcel lockers featuring a scenic mountain design.",
      "link": "",
      "alt_text": "Parcel locker with a mountain landscape wrap at Woodgate in West Jordan, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC5358.png"
    },
    {
      "id": "custom_1006d472-0a89-4fd4-8114-ec13d49288ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-3f4d-763d-9969-0bc6354d8cc2.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with dark wood cabinets, stainless steel appliances, and a glass-top dining table.",
        "public_id": "019f66ac-3f4d-763d-9969-0bc6354d8cc2",
        "storage_key": "property/6767906449166460/019f66ac-3f4d-763d-9969-0bc6354d8cc2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Modern kitchen and dining area with dark wood cabinets, stainless steel appliances, and a glass-top dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC5433.jpg"
    },
    {
      "id": "custom_25973de8-b4e1-4c79-9ffb-814478325cd1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-3fb6-7087-9e19-897929357785.webp",
      "image_media": {
        "alt_text": "Dining area with a glass table and four chairs, next to a large window.",
        "public_id": "019f66ac-3fb6-7087-9e19-897929357785",
        "storage_key": "property/6767906449166460/019f66ac-3fb6-7087-9e19-897929357785.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Dining area with a glass table and four chairs, next to a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC5438.jpg"
    },
    {
      "id": "custom_768d22e5-3c76-4d90-9517-42f5de412cbe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-439e-72ff-babe-67bd658f3c36.webp",
      "image_media": {
        "alt_text": "Living room with dining area, TV, and entryway to bedroom at Woodgate in West Jordan, UT.",
        "public_id": "019f66ac-439e-72ff-babe-67bd658f3c36",
        "storage_key": "property/6767906449166460/019f66ac-439e-72ff-babe-67bd658f3c36.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living area with a modern TV stand and a glimpse into the bedroom. Perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Living room with dining area, TV, and entryway to bedroom at Woodgate in West Jordan, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC5408.jpg"
    },
    {
      "id": "custom_464c0281-d038-4df5-b1df-e12b0b048db7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-4b3d-7159-a6db-cbcf63d9f2de.webp",
      "image_media": {
        "alt_text": "Stylish living room with a large sectional sofa, abstract art, and decorative vases.",
        "public_id": "019f66ac-4b3d-7159-a6db-cbcf63d9f2de",
        "storage_key": "property/6767906449166460/019f66ac-4b3d-7159-a6db-cbcf63d9f2de.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed living room, featuring a plush sectional sofa, modern decor, and a striking piece of abstract art.",
      "link": "",
      "alt_text": "Stylish living room with a large sectional sofa, abstract art, and decorative vases.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC5413.jpg"
    },
    {
      "id": "custom_df35f72c-4bc5-436a-be7e-c6f7610c359e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-4b3b-76b7-bd78-60119645012f.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-sized bed, plush white bedding, and decorative pillows. A washer and dryer are visible through an open doorway at Woodgate in West Jordan, UT.",
        "public_id": "019f66ac-4b3b-76b7-bd78-60119645012f",
        "storage_key": "property/6767906449166460/019f66ac-4b3b-76b7-bd78-60119645012f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-sized bed and convenient in-unit laundry facilities. Enjoy a peaceful retreat.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-sized bed, plush white bedding, and decorative pillows. A washer and dryer are visible through an open doorway at Woodgate in West Jordan, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC5463.jpg"
    },
    {
      "id": "custom_ec317fbd-61d4-4994-9d95-9b7ecc4149b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-4c9b-71fb-b88d-588fa34e7d41.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, ceiling fan, and dresser with a mirror at Woodgate in West Jordan, UT.",
        "public_id": "019f66ac-4c9b-71fb-b88d-588fa34e7d41",
        "storage_key": "property/6767906449166460/019f66ac-4c9b-71fb-b88d-588fa34e7d41.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, modern ceiling fan, and elegant dresser with a decorative mirror, offering a serene retreat.",
      "link": "",
      "alt_text": "Bedroom with a large bed, ceiling fan, and dresser with a mirror at Woodgate in West Jordan, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC5488.jpg"
    },
    {
      "id": "custom_a2144ebf-80a5-4a02-90ae-171c1fafab96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-4cf7-755f-89dd-9d5d9b931f95.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white bathtub, toilet, and vanity with a sleek sink and ample counter space at Woodgate in West Jordan, UT.",
        "public_id": "019f66ac-4cf7-755f-89dd-9d5d9b931f95",
        "storage_key": "property/6767906449166460/019f66ac-4cf7-755f-89dd-9d5d9b931f95.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Freshen up in style in this contemporary bathroom, featuring a clean white bathtub, a modern vanity with a chic sink, and elegant lighting.",
      "link": "",
      "alt_text": "Modern bathroom with a white bathtub, toilet, and vanity with a sleek sink and ample counter space at Woodgate in West Jordan, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/5742705921490944/6767906449166460/057cc41b7b4425c85afea492c46fb6ae.jpg"
    },
    {
      "id": "custom_47c2b1ee-a107-4790-b831-2ee5e85f2121",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f66ac-4f6b-73fd-8bf4-c2f315c53701.webp",
      "image_media": {
        "alt_text": "Laundry area and bathroom in a bedroom at Woodgate in West Jordan, UT.",
        "public_id": "019f66ac-4f6b-73fd-8bf4-c2f315c53701",
        "storage_key": "property/6767906449166460/019f66ac-4f6b-73fd-8bf4-c2f315c53701.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry and a modern bathroom with vanity and toilet are shown, with a glimpse into the bedroom.",
      "link": "",
      "alt_text": "Laundry area and bathroom in a bedroom at Woodgate in West Jordan, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/dc5c5ef9/dms3rep/multi/_DSC5443.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_9d7ad0d3-8bd6-430a-b339-8a8f9145ad44",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Wiseguys Comedy Club, Jordan Landing",
      "poi_type": "Entertainment",
      "poi_address": "3763 W Center Park Dr, West Jordan, UT 84084, USA",
      "poi_short_description": "Entertainment venue featuring local & nationally renowned comedians, plus casual grill fare & a bar.",
      "poi_long_description": "People say this comedy club offers hilarious shows and decent food. They highlight the fun atmosphere and the good value. They also like the helpful staff.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJo2PjyJSOUocRzbARD3R_uc8/photos/AcnlKN3KA187EAK3Rj0GAK2759XKaeDJ9joPpAW-UCkA_PweouneyP0j0pEMwVWZ5M7Jzm47XidtjGAsB1ROe4Fr9lq7TK_etP1AjNQejyycGKHrSP4p7blrYv2Jz8JC-oi3lrc7kAQzu9Q0JXV7YAslPfsbetw11ty06V4G4rfhxjC9BfNoDtj_I_rOac3bV8e6vYtaVCXObRF2dJpBaDFNGdV9eWza6FYsc38X8Ax97XfxTHiX9Uf0AiUMDRMrcmc7pwXNLgJwtn4uJ9WUvGWQzSa4ZklGQwb_wtVVEzJr-lAgiBaqEyWWG4GuK3CUtXXrUG0_hj55XEjTGBVQe3QwTIQOw_6ARxJxSbUQjpTjy2Lz6tuR7D3egxEMlq1I4H53L5z6tkuKl6ycf319qlMr1A5-jo0V6JtxMO-j2eKUI8M/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=3024&maxHeightPx=4032",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wiseguyscomedy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14968134972988305613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wiseguys-comedy-club-jordan-landing",
      "poi_latitude": "40.6195586",
      "poi_longitude": "-111.9803126",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-463-2909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2PjyJSOUocRzbARD3R_uc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "comedy_club"
    },
    {
      "id": "custom_58253567-3d74-4f75-a11e-3b78439e76f3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Nickel Mania",
      "poi_type": "Entertainment",
      "poi_address": "3245 W 7800 S A, West Jordan, UT 84088, USA",
      "poi_short_description": "A family-friendly outlet offering arcade games (some old and some new), pinball tables, ticket redemption games and birthday party packages.",
      "poi_long_description": "People say this video arcade offers a wide selection of new and classic games, including pinball machines, and fun ticket games. They highlight the affordable prices, nostalgic vibe, and clean environment. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJd8zyryuPUocReQNwLAwKD5o/photos/AcnlKN05W-zvSGPId6ki5xRxkxdNNiY4S9GzvzFgNRleBRfj9GtTJtdQx2a-mbvxhG6GCfnDuMmad7ZMCD9mUhYXMTW3YLq3PWxUly6O2NUk0w9Ar0AmomEerK_m5GE1wy-CE_CGzUT1D7wvIz9O9yLkJf5wguv4Rsq77eQPY_rLgwkuVXYnf23nVFo7sU54NfXYmTPDSROsPdXozrLXBTzIP38QG6UxjU2F9qqZ3mwT9pLE98TX3VEUBR_2kHrWTFPyCNXc49uxU_WUanFXMdX6TbYVzVBITA39bFl6cO6lffacPlnY0Ob9vqIdf-pgXJZrRhGNYAW7Ih4QVJZPJ2-pa24Ihg-OuPm8aQaRFNTPgA2I6adlzXYZE6w-eEVkPdgAK0XvsQAmlh-sktlWSSETINBf9Y9swZ6nSjYFfFnm3B-D1w/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=3024",
      "poi_featured_image_media": null,
      "poi_business_url": "http://nickelmaniaarcade.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101102653892985721&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "nickel-mania",
      "poi_latitude": "40.6082483",
      "poi_longitude": "-111.9687342",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 385-274-2828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd8zyryuPUocReQNwLAwKD5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "video_arcade"
    },
    {
      "id": "custom_bf050813-ac0e-4aca-a3f1-2a19d300bd63",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Altitude Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "3813 Center View Way, West Jordan, UT 84084, USA",
      "poi_short_description": "Family-friendly trampoline park with foam pits, a dodgeball court and a clip 'n' climb wall.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including trampolines, a climbing area, and a dodgeball court. They highlight the clean facilities, convenient location, and great weekday deals. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJt8APChuPUocRaTo3pyHylNs/photos/AcnlKN3TYzbAImfLpI3coLd7LHJGSb6zxSdgwY3lkx3cKaRrhsasroHSPON4hf9wPNk_gIuJqVndATFcIl_x6rtohe9NSeEg6EGy-InqyKM2kfXoWqntr1CDKyTkRtN_uAu4paXZrcpbkNeHHTlzvGmS-N3nwk6QM7st4oebA1PE9miyC3WpBi6Hq7qWllW0KvceraHH0CA7tcFpTpIkl_mA53llttmaP-P2UraO2z6oIifCN5uV3wpCBv4HKrDIJXsfVQJx_JnEnywWE93OgNowf4RKEXGugbHMACgeyXFF4eXWphVEsAdpdomUB2N7PSb8Bqk-JtYeFoTCz1b3SvdXkUcPnzoS5zhoOKV9rGdD30EKz1qzx5MlJ0X575yaUOUPs-Cv3N2cLYJLHkTJxuFvrHGBMUMMjB1qToRlbZKSLFua14et/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=3024",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.altitudetrampolinepark.com/locations/utah/west-jordan/3813-w-center-view-way/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15822537617212652137&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "altitude-trampoline-park",
      "poi_latitude": "40.6172418",
      "poi_longitude": "-111.9815924",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 385-255-9188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt8APChuPUocRaTo3pyHylNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_f018227e-301b-40c8-947b-c04946585d8b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "All Star Bowling & Entertainment - West Jordan",
      "poi_type": "Entertainment",
      "poi_address": "1776 W 7800 S, West Jordan, UT 84088, USA",
      "poi_short_description": "Contemporary, bustling bowling lanes & an arcade, along with a tavern featuring 10-ft.-tall TVs.",
      "poi_long_description": "People say this bowling alley offers a fun-filled experience for families, with a large arcade, well-maintained lanes, and a decent menu featuring pizza, pasta, tacos, wings, and salads. They also highlight the friendly and attentive staff, the clean and comfortable atmosphere, and the reasonable prices for bowling, food, and drinks.\n\nSome reviews mention the lanes can be prone to technical issues.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJUUpU2CeJUocRjlkJ449DO48/photos/AcnlKN2IMjUHFhpfZegI7ePw6thjb41wBBVP6N_zRcqEW7e39XoBbqvQplr8NOEjIsJrWmY5I2vjscZqSuTeCGiUpZqFquV9bNdF4YlreqmahJDftJ8QRwU90__W6RmDHoMk1eOuu2WLeq6J9dt3Vn2yXuWVdAq7wvsX0c1q8i5UxndB9QNpOvqPq1A25qud26vAyGPHRFjdsg2y_3wKzGXoE_EupI2i7b4dttZLZp42AuU5TCLbYl4vGRdl7SDd9n5DgMQQGxXf2Q0WJfKTEPln0P-JWD-vQVvt6ICjrimzXafgQg/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=2048&maxHeightPx=1365",
      "poi_featured_image_media": null,
      "poi_business_url": "https://allstarbowlingandentertainment.com/locations/west_jordan",
      "poi_directions_map_url": "https://maps.google.com/?cid=10320917256318048654&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "all-star-bowling--entertainment---west-jordan",
      "poi_latitude": "40.610916",
      "poi_longitude": "-111.9407392",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-566-6627",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUpU2CeJUocRjlkJ449DO48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_5b1f9b33-8f59-44a6-a3fc-54dcf0bf5ac3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Cinemark Jordan Landing 24 and XD",
      "poi_type": "Entertainment",
      "poi_address": "7301 S Jordan Lndg Blvd, West Jordan, UT 84084, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "People say this movie theater offers comfortable reclining seats, a wide variety of snacks, and a good movie-watching experience. They highlight the clean theaters, reasonable prices, and wheelchair accessibility. They also like the friendly staff and the convenient online ticketing system.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJw0D5RuuOUocRR3t5VboKyL8/photos/AcnlKN2V11wz9Q4JOfMG9GrAJxsAPmSBfjCgq6K3sBJkypUwR9Fwww5yr9DggdkKm81sVLaaFuoXg7J9qLO4UdoIgV75MqqsFgyL7BRMMqvxo4fwp1oByxhQe8at2C8Gd1g9l_QRefQQL8AbESGq__8nunYTNsTRcJkPQSGufBGqCBika8hj8KQmKl744UNeqFtCGrTu15Sc13jsYayRye9i4mRiapgyvoIwgCHwrprByv_19orkMYvmrJw-EUQ_QYNKkgZihmHzx2F2nJ_gz9jzCAJHPDM8DS3CJAyXOzyaXQS3-pmjlD1qClktuehCJvZuha1S5-rK-M-oUVwdkxnawCiNokjsJ5X0zk2Ku9WzNzFqsPenShjSyaOWUG_6GqqjJjVgrdznJXBISxlZ_5StCmB5xJLl0TIz3-cxTOLz3J2wXg/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=3024",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cinemark.com/theatres/ut-west-jordan/cinemark-jordan-landing-24-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxMDgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13819307252000586567&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinemark-jordan-landing-24-and-xd",
      "poi_latitude": "40.6191803",
      "poi_longitude": "-111.9815051",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-282-8847",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02d1-1af6-730e-af13-9e8981a29341.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-1af6-730e-af13-9e8981a29341",
        "storage_key": "property/6767906449166460/019d02d1-1af6-730e-af13-9e8981a29341.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJw0D5RuuOUocRR3t5VboKyL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_0dc90ee2-2bd0-4633-b6fe-658c9f908f55",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "The Rush Funplex",
      "poi_type": "Entertainment",
      "poi_address": "7323 Jordan Landing Blvd, West Jordan, UT 84084, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement center offers a wide variety of activities, including go-karts, laser tag, bowling, mini golf, bumper cars, and an arcade. They also highlight the fun and family-friendly vibe, and the helpful and friendly staff.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJkRpmA0CPUocRemT5N1IJSgA/photos/AcnlKN31JK3eNOUPzSv6GhdW2ajrikkDioGbC8pNXT4IDIRwJjx3_uU6rtsyhH376u7nCBtcetxWX2ZFvPO_F8s2876-B-9B96A5259M-opFKU0TYDr684cfWKgpy25tg4GDXzEKckflVtVuGnBzyL90ut241VAuBi-TJn4zK86dMJWRtkiqJ3Iv57a9yANaj8_dsFQsK4zkSpmre8myet_NOkPXdPilmpZ1pflfsC_39N18erJASFWXjgtx0Jpi-6W7f9JfnHuh5zwVi6gUv6_3vCPKI_O3kiISpaXGtuO0K9St3w/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=2102&maxHeightPx=1130",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.therushfunplex.com/west-jordan-ut/",
      "poi_directions_map_url": "https://maps.google.com/?cid=20839397007647866&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-rush-funplex",
      "poi_latitude": "40.6180813",
      "poi_longitude": "-111.9810418",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-849-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkRpmA0CPUocRemT5N1IJSgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_61ed8edc-00aa-42f7-ae88-3319b0fff824",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Lucky's Iron Door Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "3754 Center View Way, West Jordan, UT 84084, USA",
      "poi_short_description": "Casual eatery offering beer, burgers & sandwiches in an industrial-chic space with TVs & a patio.",
      "poi_long_description": "People say this restaurant serves amazing burgers, including the Nut Butter Burger, and delicious fries, such as garlic and Cajun. They also highlight the fun, lively atmosphere and the friendly, attentive service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJoTOzmdaPUocRKvq0IcOknQY/photos/AcnlKN0oeVBiSBXgChoPFVbsCkIqB5Wuk9oGvhNdvtu7Sfnyi8I2VqkE3TX0gqvues9NPZNV4fa6dK7V3OIZNq81yODJ_V3Kd9DE-zAs_8WhQuFTfG_R41sI23ZrP0PIJqAz-09Y1p2UVh9SKmVtbW7te2f3-7SjoIruWhD3wW9hiqRuNplzF_r_O0AQFnouUTbADwjtPIg6Dnmtlr6BKrR3320LkUAo2cc-N7YR4QRL2utOwuD50Q43fcqV4B52oao0b36vTfRWAOGbAs57ozmMNrytg-Cjpljb8mV8ggdLmLw3Kw/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1080&maxHeightPx=1350",
      "poi_featured_image_media": null,
      "poi_business_url": "https://luckysirondoor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=476718293562227242&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "luckys-iron-door-roadhouse",
      "poi_latitude": "40.6193469",
      "poi_longitude": "-111.9802343",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-878-9439",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d41a-7498-b502-3cf77e963197.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d41a-7498-b502-3cf77e963197",
        "storage_key": "property/6767906449166460/019d02ce-d41a-7498-b502-3cf77e963197.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoTOzmdaPUocRKvq0IcOknQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_af443b0b-cbfe-4216-94c1-65382ff965fc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "The Break Sports Grill",
      "poi_type": "Restaurants",
      "poi_address": "11274 S Kestrel Rise Rd, South Jordan, UT 84095, USA",
      "poi_short_description": "New American pub grub & cocktails served in a laid-back sports bar with karaoke, pool & a patio.",
      "poi_long_description": "People say this sports bar offers a variety of good food, including mac and cheese with burnt ends, smash burgers, and fried pickles. They also highlight the fun atmosphere with pool tables, darts, and live music, as well as the friendly and hospitable staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ4xdbm3eFUocRwV3LT2f2SuU/photos/AcnlKN1fNg1OjNMxlqca8VtDi9GViGHs_D4VeQK8MAu9ORnYjxzghoKC7PV6I3T68AQ5wgfbjSld6etKthlhUFnAnpLThw5_A7SapPLQffjomQRdIvCWJrc8TJUxAIplDtxK4VpTswunWFU8wDkskPiL8Kna4C8Au2lu3nI-dxo5ByWh4pxCtrg1KZufRyBVu4qr5p3SXPemeKHjrUxga0vDdePEn5F4bw35GAFfHhv2ys1WnYIpz2tsi4u9KZzWjXIuJf7GbXV4XVVUmeIV1ITGhPsg4q33pQtmzMtnxFwVUQaCwg/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1280&maxHeightPx=791",
      "poi_featured_image_media": null,
      "poi_business_url": "http://thebreakgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16522289106542878145&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-break-sports-grill",
      "poi_latitude": "40.5467027",
      "poi_longitude": "-112.0023892",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-987-3354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02d1-1ac9-75b7-a329-779e9b63bbf4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-1ac9-75b7-a329-779e9b63bbf4",
        "storage_key": "property/6767906449166460/019d02d1-1ac9-75b7-a329-779e9b63bbf4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4xdbm3eFUocRwV3LT2f2SuU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_90621f02-0f91-44bd-8ecc-738105970f88",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Tepanyaki Japanese Steak House",
      "poi_type": "Restaurants",
      "poi_address": "7233 S, Plaza Center Dr, West Jordan, UT 84084, USA",
      "poi_short_description": "Stylish local Japanese chain featuring chefs performing at tableside hibachi grills, plus sushi.",
      "poi_long_description": "People say this Japanese restaurant offers delicious food, including steak, chicken, lobster, and sushi. They also highlight the fun and entertaining experience of watching the chef cook at the teppanyaki grill, and the friendly and attentive service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJkWD71JSOUocRA5AfglG2zlY/photos/AcnlKN2zOSxwOw4B0egAbB5LoPmT1pq_Zb1V93_UZvOl4RSfnOyAu3O_keTlcTx35-xK_6e9Ami8pab4v3fwr21cHq4TWgq0IwIVKJX0vs7yU0Yj9I6LKCpcQXZ-0qDzeFEq2_MzG_G8OrrpS2TdJvF2BKkejV5-FJvvcblRppr3BQqUTKQKHT_RRK3yEuMG9f1GpCFT2Zqpfkjde5b9tQ_yRUkrRUdzxPIIBcHd9gpRmoBtoXgBMuG1uvBkI6Ax356Ydhq99wYnEGFxiGqTDbwIyJE7CB5EiPy3z7mrD3nVjsxeLpTKrXyIWnUah_db_HtFdPBtoRASR1rju6lqTYhAw5-MSDosQiliZ2j7xQxG_Bj22Klyr1Z_OL0eQJmB8QsgYxfcj9FsUTw2nlHgAtjqc9tfyqezG5i8E4rksFcrWnZTJrTZ/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=1960",
      "poi_featured_image_media": null,
      "poi_business_url": "https://mytepanyaki.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6255137393655910403&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tepanyaki-japanese-steak-house",
      "poi_latitude": "40.61977539999999",
      "poi_longitude": "-111.9789375",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-282-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d41a-7498-b502-3cf77e963197.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d41a-7498-b502-3cf77e963197",
        "storage_key": "property/6767906449166460/019d02ce-d41a-7498-b502-3cf77e963197.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkWD71JSOUocRA5AfglG2zlY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_cb1828db-7ad2-4ce2-9a0f-19e60e11feb3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Black Bear Diner West Jordan",
      "poi_type": "Restaurants",
      "poi_address": "7238 Plaza Center Dr Bldg E Bldg E, West Jordan, UT 84084, USA",
      "poi_short_description": "Easygoing chain serving familiar all-day comfort food & desserts in a woodsy setting.",
      "poi_long_description": "Diners say this American restaurant serves delicious pancakes, sausage patties, and cinnamon roll French toast, and they praise the huge portions and reasonable prices. They also highlight the friendly and attentive service, especially from Patty, and the homey atmosphere.\n\nSome reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJhWWg0ZSOUocRgKTSuAvbCjk/photos/AcnlKN2wfkAk01VoWvhq2YBVg9cN-uI_LV7Iq5iIFB0JFpJ8AZShjdKhQJfWMWVq7iiwFqYfP2wsTHQ7WxBzpvg1m7fNo4DggvoolEkXtRF-xAk8A-l7jEFkn3Zz6ghtWTqoYggC9cJLX9W_QIJwUZYgtPpLDlMytMmP26A4alYb0UF01EEM_M4mM4N3iaqEFPfIWp2iOz8jrkBAWGpMh_zXOUYa9yf6EKbrrrniVl0sbANq131bnjDL1ioAUs42jicZyftmKMogMJyrZxOnguYR9kEKRs7Pcb46uTChvlebuWBWuu9tBH4A0WdD_HPGrX0gFUE1JHGnCXj-BG7ALgD32fo0XxV8q-CBGx0P5-XiAbfAgO04Z37bdZHbwGwaIYcXUOH2OZXWNziHhrkR3R5gktLhKgZn0twFj_MF3Kw0AC0s8remQP2D6XYejRu4CDQK/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4080&maxHeightPx=3072",
      "poi_featured_image_media": null,
      "poi_business_url": "https://blackbeardiner.com/location/west-jordan/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4110338453320934528&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "black-bear-diner-west-jordan",
      "poi_latitude": "40.6197303",
      "poi_longitude": "-111.9796803",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-282-0077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d41a-7498-b502-3cf77e963197.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d41a-7498-b502-3cf77e963197",
        "storage_key": "property/6767906449166460/019d02ce-d41a-7498-b502-3cf77e963197.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhWWg0ZSOUocRgKTSuAvbCjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_657884b1-d658-4391-ada4-4e7ab9107641",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Nike Factory Store - West Jordan",
      "poi_type": "Shopping & Retail",
      "poi_address": "3736 W Center Park Dr Suite 120, West Jordan, UT 84084, USA",
      "poi_short_description": "Big chain outlet for sneakers and sportswear featuring a Jordan section.",
      "poi_long_description": "Shoppers say this sportswear store offers a wide variety of Nike shoes and clothing at great prices, with many mentioning the clearance rack as a good place to find deals. They also highlight the clean and well-organized space, and the friendly and helpful staff.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ7a5idZWOUocR0N4-RtWInSk/photos/AcnlKN0uci9F8Gmv7hNKMMXTkSnOFNypy6E0CkocHDK_D6FYoxMQ1Tdcp5VqCJR8cXPw_CWhij_Spb4Mp5nYVzjmOqztKfS4b59vRWLHfjtJH2aZ4FOzszZSI4sGoHEwovA7EXnB6NdbCiTDaQ_8Y0xZ4IrFsuJaG2pxGlH5BkpWATZs8XjLYOSkoL7cVrp-kgvRAxqqo78vFN7u5VXr0Vl3kXw9fjbQ9TGJjR8A6icDz-eoGodQ-VuOzxVmwyZhYUEsTgS540EiYwu0BYY0FoV4u62PP-rllnZ67_-Ae_GsbhX1AIYjT_kKAbOHUi2329ozUbZkSPrqw_A8JbScRflQgcXcEXCVAW5qCj4q-ZzhBe2opWJ2Jq6c8k9jk36ku6anPMDI2IWpi_QgIIpOqgwzBY_RssONpE5YpcMTWtBgUg6ciW9k/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=3024",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.nike.com/retail/s/nike-factory-store-west-jordan?cp=84620811901_seo_%3Fcp%3D84620811901_seo_&y_source=1_NTQzNzQ2My03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2998703376486555344&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "nike-factory-store---west-jordan",
      "poi_latitude": "40.6223937",
      "poi_longitude": "-111.9797842",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-282-1269",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d42a-731b-81ce-c5a3468d61fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d42a-731b-81ce-c5a3468d61fe",
        "storage_key": "property/6767906449166460/019d02ce-d42a-731b-81ce-c5a3468d61fe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7a5idZWOUocR0N4-RtWInSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_e753c806-7660-478f-a392-a93a2c1936c0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Jordan Landing",
      "poi_type": "Shopping & Retail",
      "poi_address": "3751 W Center Park Dr, West Jordan, UT 84084, USA",
      "poi_short_description": "This mall features brand-name shops, big-box stores, restaurants, a movie theater & trampoline park.",
      "poi_long_description": "People say this shopping center offers a wide variety of shops, restaurants, and a movie theater. They also highlight the convenient location, ample parking, and clean, well-maintained facilities.\n\nSome reviews mention the area can be crowded.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJxX9O1JSOUocRpqR7aa7PsUI/photos/AcnlKN0eXz2rerzcffMZtFy8XLYe7Se9h-7W0xi_kMTAwKqDZyuyOPqOQGUOAfCWM36hsv8SXn6uuDH-LTuJrYRg8o0rDyKfCdoR5CnEoAuojYVYlnrvheiSSuSyDqaDLsKOSExUDytwNZliKFR0Gwk53z9bza1FAzjkHrYxTZI81TfzyvsFAFLWAT5zemu2aP-k7JHaeu2MbA2zI-aG9UOrz1zu-YMQJkDZ8Dq290gJdLZGjUlcOpuafklw7cOQddXSsbdTbPN3BghXTnT56lSq8jUTrq0rDQVb6rN_HhtO3fIw0w/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=3000&maxHeightPx=2000",
      "poi_featured_image_media": null,
      "poi_business_url": "https://jordan-landing.com/?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4805850625381999782&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jordan-landing",
      "poi_latitude": "40.6197417",
      "poi_longitude": "-111.9799732",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-282-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d42a-731b-81ce-c5a3468d61fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d42a-731b-81ce-c5a3468d61fe",
        "storage_key": "property/6767906449166460/019d02ce-d42a-731b-81ce-c5a3468d61fe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxX9O1JSOUocRpqR7aa7PsUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c65ceace-ff02-4fc4-8a4c-4a719aaca448",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Fashion Place",
      "poi_type": "Shopping & Retail",
      "poi_address": "6191 S State St, Murray, UT 84107, USA",
      "poi_short_description": "Sprawling indoor complex with merchandise of all kinds, a food court, grooming services & more.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including Nordstrom, and a good food court. They also highlight the clean and well-maintained facilities, and the convenient parking.\n\nOther reviews mention the food court can be crowded.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJa8t_-L6JUocRSDburU1ahp4/photos/AcnlKN2L1_ok4apdDr0gnuUlzRhIDtHQItnpCTF4pJUnJfLpsV99fieZGjM_-weOFsNkYxVvIdJZge_yyW_A-XCdkGDBvBm3rqTk2oCbV8yqQVb3VpFZZjtYuWTDyMwUR1-g5kNYYRICae_qH83crpDCtSS_-u0n6XeW8xYRU41CT4zz4mGHMkeOKUf_kLbO2QGrDX233zVH1rI0a2Zfg6reBhDdK148s4zP_bhuo7dKO7ESVqpmfW5fegxv2EAC8SuuLYkDZHBFzVBh9-f-jcrRUnbHotvQP_-1-DzWKVmliC7kqA/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=2880&maxHeightPx=1147",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.fashionplace.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11422916794548893256&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fashion-place",
      "poi_latitude": "40.6372542",
      "poi_longitude": "-111.8868617",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-262-9448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d42a-731b-81ce-c5a3468d61fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d42a-731b-81ce-c5a3468d61fe",
        "storage_key": "property/6767906449166460/019d02ce-d42a-731b-81ce-c5a3468d61fe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa8t_-L6JUocRSDburU1ahp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_519ea6c4-d2a6-40c9-ab19-6e21f48c49f6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "7571 S 3800 W, West Jordan, UT 84084, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Shoppers say this warehouse club offers a great selection of products at competitive prices, and they appreciate the friendly and helpful staff. They also highlight the clean and well-organized environment, making it easy to find what you need.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJRfeimOmOUocRDZ6-Num4yGc/photos/AcnlKN0RWJgxCB8G7jn5K3ChXliJtLlrhsAjrlm2wArsqS1h8OJgsN21KUxqwsKYHFUVFEtx2YEEnjDsQUv6wNDZYa7qoTo6nwdyQngaW5KGLYyukcf-ESGH75EN6GywJLc2tuS-9OxInOwsjHjR9NoZ8A22vXGx4u0hTBsEwnOw5Q9FQPVdaav0lJst5F2E30E3KgFE9JKrgwXr0orzODUiNlR3NnitSz9TDmwSQfpE-JzzDe2zang9ULd4js7J6U2SSRzv6RUukk8ytNWJnWxYIELPku8t4o_4FR68T9dencadcYWOfT_MhIpy-5G2vAi3sOfrZF1WghTtom3wtyRrb8Ox8yLUKx_bW673KzrNoPwV-uiZ9KlEFLZqNIJwWs0FnmasjF3pQ-4vt0A7TfOafrvvv6Lg4qqia9GCz5qfH47wuw/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=3024",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.samsclub.com/club/4730-west-jordan-ut",
      "poi_directions_map_url": "https://maps.google.com/?cid=7478430493034061325&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "40.6138347",
      "poi_longitude": "-111.9783418",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-282-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d42a-731b-81ce-c5a3468d61fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d42a-731b-81ce-c5a3468d61fe",
        "storage_key": "property/6767906449166460/019d02ce-d42a-731b-81ce-c5a3468d61fe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJRfeimOmOUocRDZ6-Num4yGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_9837e075-9732-4ce4-a697-7b91a69ce4d7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Harmons Grocery - Cougar",
      "poi_type": "Shopping & Retail",
      "poi_address": "4872 6200 S, West Jordan, UT 84081, USA",
      "poi_short_description": "Neighborhood grocery chain with produce, a deli, and a pharmacy, plus vegan and vegetarian options.",
      "poi_long_description": "",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJT_sjatGNUocRFgXziPF-W1I/photos/AcnlKN3nsmyE7IJRMH96itN9W-2uzYhJTw2EiMSrhkMJYe8t5BCMye1tDhzH8NvytV9WJ0DzH5Rc1bXzTZPFnN3v9uHFbvRVQ_UkBoLY02kVz76gNYGaBZG1kFxr4FRSk9uLedhVVPdzkOolocAnvXOhRktJJ9g4kx_sB9Ic5E0lrQaHpuIy1Z-Z00RjHBmyNwqMQXdZEnEtNYJEsgvbP_Te5_uS2GERk0SXH4CAqziEgU0i_DzBhttwSmzsBbtUvdSMJQWhd04InZGSHLhrBEHR8FL7xRi7AXCnpsWuZKVQbEjgVi8ZJoPGPhDxrA_DKZ_FKd6EzmgOj9kTdiOFi4E71ILtL3KV8x717V5W9W9k81kvTw8KSeXvzA3tVlnVeb8ZsI7lttsgdVVEIENVj8Kr7odLODP3wCLy12WJVVO-J_em1udU/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=3024&maxHeightPx=4032",
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.harmonsgrocery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5934476509840606486&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "harmons-grocery---cougar",
      "poi_latitude": "40.6397995",
      "poi_longitude": "-112.0072822",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-965-9450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d41f-706e-9eb0-43bbcfe21d33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d41f-706e-9eb0-43bbcfe21d33",
        "storage_key": "property/6767906449166460/019d02ce-d41f-706e-9eb0-43bbcfe21d33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT_sjatGNUocRFgXziPF-W1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5c15b6e4-f36c-4a0f-a840-b453d08590ed",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "7779 Jordan Landing Blvd, West Jordan, UT 84084, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide selection of products and is well-organized.\n\nOther reviews mention the customer service can be unhelpful and the staff can be unavailable.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ749ITO6OUocRnPFj3uKNwz4/photos/AcnlKN0I7wEPUM7kzspEtp8yc_L5AmEjGKorRtZxjy-D89qgFdfCNSObCQWA1bqlGnzcKlUSOWv6HkfewINu6Tsl7LfRFSmzGGxM-3IpO8_vB6HDUejIVNfJgxj6hHBZ68YR1nPiSJys5FbMs_mMBN48H_xefYx9nvFbzm0UDOiWNzt22yUjwiv_i4ytSytgLGL4kyATZyAa_EUPirApvF1OBow4n4757ALH9ROoybdrlPoc0x-Zr-tYo29Wv7vUqL7PV5Mshpu5M0HMzjhtOBAYct9mu4kyeHdMRNoh1MsvB3ST9OjlpkIF7t5GAm18t9GkVTq2vKSGsAKAgmejy6OHR4chP7Odou40zI-b5sNryAbTHFRxBcGPeb4M9twIoseyiW87N4gXQ-TVKVjpE7K9FzJzgsRS8E5b2pIoQ6lSau4WbA/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=3024",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.target.com/sl/west-jordan-sw/2150",
      "poi_directions_map_url": "https://maps.google.com/?cid=4522614456343327132&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "40.6103477",
      "poi_longitude": "-111.9837341",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-316-0049",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d42a-731b-81ce-c5a3468d61fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d42a-731b-81ce-c5a3468d61fe",
        "storage_key": "property/6767906449166460/019d02ce-d42a-731b-81ce-c5a3468d61fe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ749ITO6OUocRnPFj3uKNwz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_4ddfdcdc-fc81-4f5b-996f-15cb2a35902a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Archibald's Restaurant at Gardner Village",
      "poi_type": "Restaurants",
      "poi_address": "1100 W 7800 S, West Jordan, UT 84088, USA",
      "poi_short_description": "This restored 1877 flour mill houses a cozy eatery with a long menu of hearty American favorites.",
      "poi_long_description": "People say this restaurant serves delicious fried avocados, chicken sandwiches, and salmon. They also highlight the fun, rustic atmosphere, and the attentive, friendly service.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJR6xyCeGIUocR31WRWryqgcI/photos/AcnlKN3i7VfIg2O8mUtewd_bb7VdVWyTq4cpAMilndXeDQC2x7CfNNKDF7unOMepYb8OkzOqncPWTPeSHSvsWEVHq0DhgXCKD5x_O21qljSEHmlcYxgIBxqf3Vo_9EG_TgmEB3S9yNsJQz66BlKgq7cmDbXOSt6uB56cre_TiPM6xLQiuCyvK2Fd3EWggPwEG7yS7Tx9NBQF8wryZTGNUdAxE9WOflZRRvNc4AWKQnjxFUKrwOMNTBhCMzTXnN_HVfWOJoRX_gGLJErzXb-l5WbgvUAJH95_79mmkVZAXDdmU4dh2g/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4800&maxHeightPx=3200",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.gardnervillage.com/archibalds-restaurant",
      "poi_directions_map_url": "https://maps.google.com/?cid=14015671241303741919&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "archibalds-restaurant-at-gardner-village",
      "poi_latitude": "40.60942989999999",
      "poi_longitude": "-111.9232959",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-566-6940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d41a-7498-b502-3cf77e963197.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d41a-7498-b502-3cf77e963197",
        "storage_key": "property/6767906449166460/019d02ce-d41a-7498-b502-3cf77e963197.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR6xyCeGIUocR31WRWryqgcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_d590b63d-f0bf-4de1-8bf1-59ac8f4f74dc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Garage Grill & Salt Flats Bar Herriman",
      "poi_type": "Restaurants",
      "poi_address": "12547 Herriman Auto Row, Herriman, UT 84096, USA",
      "poi_short_description": "Wide-ranging American dishes share the menu with sushi at this comfortable restaurant featuring car memorabilia.",
      "poi_long_description": "Diners say this restaurant serves up delicious sushi nachos, fish and chips, and a variety of burgers, alongside an expansive beer selection. They also highlight the fun and unique atmosphere, with its car theme and impressive collection of luxury vehicles.\n\nSome reviews mention the burgers can be dry.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJDTS580yFUocRH8njndD5PvY/photos/AcnlKN1n9ArwFT9d-EOZ0b4jD04Lt8oS2Fk-8tV4pq_QK-OH9bZiTiyofxvHC166vMtlo2hYUIKunvHQGwifuPxB2VpMIw6pHqxESCSIDPfUwivyx69Cofng8shiWMkpCkSCgk-I4NxvcpgyFxuAblgiC9pD0dgF3j9Lu4k0ga5liCFnf9GO9-NrKdjDhBFPFRfpsIXff3Z3PoRO_njJSEBwg5t1QAKzsjHJBLRQQkofv5ERzAxojzrFFa_gq92LGIwfZqnljNXzeZ3P8ydKdXe-C_AkZxWYmPWtuYHGvLCBgw9ZYw/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1360&maxHeightPx=766",
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.thegaragegrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17743894256283797791&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "garage-grill--salt-flats-bar-herriman",
      "poi_latitude": "40.5237792",
      "poi_longitude": "-112.0068122",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-666-7767 ext. 1",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d41a-7498-b502-3cf77e963197.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d41a-7498-b502-3cf77e963197",
        "storage_key": "property/6767906449166460/019d02ce-d41a-7498-b502-3cf77e963197.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDTS580yFUocRH8njndD5PvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_94c29608-e34b-47d3-a3b6-b6457c9e4f4e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Salt Lake Community College (SLCC) Jordan Campus",
      "poi_type": "Education",
      "poi_address": "3491 W 9000 S, West Jordan, UT 84088, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-97b2-71ad-9c67-8f1a39c736fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-97b2-71ad-9c67-8f1a39c736fa",
        "storage_key": "property/6767906449166460/019d02ce-97b2-71ad-9c67-8f1a39c736fa.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://slcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18069080376783748575&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salt-lake-community-college-slcc-jordan-campus",
      "poi_latitude": "40.5853303",
      "poi_longitude": "-111.974054",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-957-4111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d426-72f3-8873-f21dd6a76ae9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d426-72f3-8873-f21dd6a76ae9",
        "storage_key": "property/6767906449166460/019d02ce-d426-72f3-8873-f21dd6a76ae9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjfXQSD6PUocR3z0tXN5Ewvo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8970c54d-2048-4b40-97a7-a9d880dbaff8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10996 S River Front Pkwy, South Jordan, UT 84095, USA",
      "poi_short_description": "Club with an outdoor pool and a rock wall, plus a spa, tennis courts and a basketball court.",
      "poi_long_description": "People say this gym offers a variety of equipment and classes.\n\nOther reviews mention the membership can be expensive and the customer service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-a974-703c-a4b6-8e73645c8528.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-a974-703c-a4b6-8e73645c8528",
        "storage_key": "property/6767906449166460/019d02ce-a974-703c-a4b6-8e73645c8528.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ut/south-jordan.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=4100501561270111315&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "40.55176830000001",
      "poi_longitude": "-111.9183224",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 801-302-0909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuf_1skeGUocRU4xw0HHo5zg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dd2e0fac-dd29-4c35-95ec-82bc078f69b6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Kearns Oquirrh Park Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5624 Cougar Ln, Salt Lake City, UT 84118, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center offers multiple pools, slides, diving boards, a steam room, sauna, and gym. They also highlight the secure lockers, fun activities for kids, and attentive lifeguards.\n\nOther reviews mention the facility can be run down.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-ab6d-757a-ba10-e2b8e0a926d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-ab6d-757a-ba10-e2b8e0a926d8",
        "storage_key": "property/6767906449166460/019d02ce-ab6d-757a-ba10-e2b8e0a926d8.webp",
        "width": 1280,
        "height": 581
      },
      "poi_business_url": "https://oquirrhrec.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12482739114814809778&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kearns-oquirrh-park-fitness-center",
      "poi_latitude": "40.6489662",
      "poi_longitude": "-112.0067976",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-966-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW5-9_MuNUocRsiZpqhaZO60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_485b2f0f-6fa4-42ea-8f11-5ccfc85bddbb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7135 Plaza Center Dr, West Jordan, UT 84084, USA",
      "poi_short_description": "Clean, spacious gym featuring exercise classes, a lap pool, locker rooms, and free weights (up to 150lbs) as well as fitness equipment such as treadmills.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, fitness classes, and amenities, including a sauna, massage chairs, and kid care. They also highlight the clean facility, friendly staff, and positive workout environment.\n\nSome reviews mention cancellation can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-a531-7082-9105-7ef0ea4f1aec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-a531-7082-9105-7ef0ea4f1aec",
        "storage_key": "property/6767906449166460/019d02ce-a531-7082-9105-7ef0ea4f1aec.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/west-jordan-plaza-center/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=403022163835002639&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "40.6214733",
      "poi_longitude": "-111.9776731",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 801-877-6445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU5_nd3qPUocRD5_-z4XSlwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f77e5e1d-3ed8-4fb6-b808-e1543297bdd7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5345 4015 W, Taylorsville, UT 84129, USA",
      "poi_short_description": "Chain fitness center with a pool, cardio and weight machines, and a variety of group classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-b209-7529-89fd-cbff3c08129d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-b209-7529-89fd-cbff3c08129d",
        "storage_key": "property/6767906449166460/019d02ce-b209-7529-89fd-cbff3c08129d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://vasafitness.com/locations/ut/taylorsville/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=18155856233123874829&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "40.6543948",
      "poi_longitude": "-111.9852254",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-912-0233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ46lPVDiMUocRDQhp2AyP9vs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7db05be0-93f7-404f-8931-a195aa465b7d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1836 W 5400 S, Taylorsville, UT 84129, USA",
      "poi_short_description": "Chain fitness center offering a variety of workouts and 24/7 access.",
      "poi_long_description": "People say this gym offers a great workout with new equipment. They also highlight the clean and spacious environment, and the friendly and helpful staff.\n\nOther reviews mention the cancellation process can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-b2fa-7459-9c57-187b350d5700.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-b2fa-7459-9c57-187b350d5700",
        "storage_key": "property/6767906449166460/019d02ce-b2fa-7459-9c57-187b350d5700.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/salt-lake-city-54th-and-redwood-ut?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=14944865193042254149&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.6543407",
      "poi_longitude": "-111.9414577",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-963-8787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9bqdxPqLUocRRRliN7bTZs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c60cff6f-c936-4e22-ba08-1d851153a175",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "CommonSpirit Holy Cross Hospital - Jordan Valley",
      "poi_type": "Health and Wellness",
      "poi_address": "3580 W 9000 S, West Jordan, UT 84088, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-b41e-73f2-8900-7456854aadb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-b41e-73f2-8900-7456854aadb6",
        "storage_key": "property/6767906449166460/019d02ce-b41e-73f2-8900-7456854aadb6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mountain.commonspirit.org/location/holy-cross-hospital-jordan-valley/hc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7956017720439178954&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "commonspirit-holy-cross-hospital---jordan-valley",
      "poi_latitude": "40.5901957",
      "poi_longitude": "-111.974699",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-561-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d92b-76df-a938-15ca9a13fe59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d92b-76df-a938-15ca9a13fe59",
        "storage_key": "property/6767906449166460/019d02ce-d92b-76df-a938-15ca9a13fe59.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ytMaT2PUocRyoZ9xfZzaW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d09dc480-21fb-4b34-a1d9-ceb7cbb3f3a5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Intermountain Health TOSH Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "5848 S 300 E, Murray, UT 84107, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-b683-71af-9ea1-d90f878ebbca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-b683-71af-9ea1-d90f878ebbca",
        "storage_key": "property/6767906449166460/019d02ce-b683-71af-9ea1-d90f878ebbca.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://intermountainhealthcare.org/locations/the-orthopedic-specialty-hospital/?utm_campaign=gmb&utm_medium=organic&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2685071645817781934&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intermountain-health-tosh-campus",
      "poi_latitude": "40.6441568",
      "poi_longitude": "-111.8834631",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 801-314-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d92b-76df-a938-15ca9a13fe59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d92b-76df-a938-15ca9a13fe59",
        "storage_key": "property/6767906449166460/019d02ce-d92b-76df-a938-15ca9a13fe59.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJbfG76X6LUocRrj5xjW9KQyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_191077b3-0771-411c-93ac-1c46d3c2d9b2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Murray Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "296 E Murray Park Ave, Murray, UT 84107, USA",
      "poi_short_description": "Family-friendly green space featuring shaded playgrounds, walking paths, an ice rink and a pool.",
      "poi_long_description": "People say this park offers a variety of amenities, including playgrounds, picnic areas, sports courts, a pool, and a rose garden. They highlight the park's spaciousness, clean walking paths, and the presence of a creek, ducks, and squirrels. They also like the availability of pavilions for parties and the farmers market on Saturdays. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-b860-73ab-8b79-dc6ab8a232fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-b860-73ab-8b79-dc6ab8a232fe",
        "storage_key": "property/6767906449166460/019d02ce-b860-73ab-8b79-dc6ab8a232fe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://murray.utah.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1242524381665348101&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "murray-park",
      "poi_latitude": "40.6591377",
      "poi_longitude": "-111.8821343",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 801-264-2614",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d95e-77ba-86af-4ac3adc35bf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d95e-77ba-86af-4ac3adc35bf8",
        "storage_key": "property/6767906449166460/019d02ce-d95e-77ba-86af-4ac3adc35bf8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw2gVciGKUocRBcrsiVdVPhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_83f1b41a-32de-4f9e-a729-7877cc2a3fb4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Mulligans Golf & Games",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "692 W 10600 S, South Jordan, UT 84095, USA",
      "poi_short_description": "Casual option for beginners to practice golf skills at a driving range, plus 2 miniature golf courses, a par-3 course and a batting cage. Friendly staff are on hand to help.",
      "poi_long_description": "Visitors say this golf course offers affordable mini golf, a driving range, and a par 3 course, and they appreciate the inexpensive prices. They also highlight the fun and relaxed atmosphere, making it a great option for families, beginners, and casual golfers.\n\nSome reviews mention the course can be in poor condition.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-b990-702c-9f94-7f6f44f00b60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-b990-702c-9f94-7f6f44f00b60",
        "storage_key": "property/6767906449166460/019d02ce-b990-702c-9f94-7f6f44f00b60.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.sjc.utah.gov/157/Mulligans",
      "poi_directions_map_url": "https://maps.google.com/?cid=11913958679238437611&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mulligans-golf--games",
      "poi_latitude": "40.5597916",
      "poi_longitude": "-111.9105142",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 801-254-3377",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-ddbd-77ec-8ca6-f7ce85e21ca8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-ddbd-77ec-8ca6-f7ce85e21ca8",
        "storage_key": "property/6767906449166460/019d02ce-ddbd-77ec-8ca6-f7ce85e21ca8.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJbbiA2TCGUocR62qwwEviVqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_4016f37a-e883-4645-867c-a00683cd4ad6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "River Oaks Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9300 Riverside Dr, Sandy, UT 84070, USA",
      "poi_short_description": "Challenging course, along with a pro shop and a driving range, featuring friendly service.",
      "poi_long_description": "Golfers say this golf course is in great condition and has a nice driving range. They also highlight the friendly staff.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-bb79-72bd-b394-c54cfa18c7ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-bb79-72bd-b394-c54cfa18c7ac",
        "storage_key": "property/6767906449166460/019d02ce-bb79-72bd-b394-c54cfa18c7ac.webp",
        "width": 1280,
        "height": 702
      },
      "poi_business_url": "http://sandy.utah.gov/departments/parks-and-recreation/river-oaks-golf-course",
      "poi_directions_map_url": "https://maps.google.com/?cid=2515179645176061063&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "river-oaks-golf-course",
      "poi_latitude": "40.5822156",
      "poi_longitude": "-111.9174284",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 801-568-4653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-ddbd-77ec-8ca6-f7ce85e21ca8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-ddbd-77ec-8ca6-f7ce85e21ca8",
        "storage_key": "property/6767906449166460/019d02ce-ddbd-77ec-8ca6-f7ce85e21ca8.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJf7X6tISIUocRhxwDsY-25yI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_1c588e26-91b4-47ee-82c3-1bd8e663eec4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Veterans Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1985 W 7800 S, West Jordan, UT 84088, USA",
      "poi_short_description": "Large park with a playground, plus baseball fields and volleyball courts.",
      "poi_long_description": "People say this memorial park offers a variety of playgrounds, sports fields, and a library, as well as a memorial statue area and a stage. They highlight the park's large size, clean restrooms, and ample parking, and appreciate the safe and family-friendly atmosphere. They also like the convenient location near other centers and the well-maintained grounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-bdc0-74ae-a3b3-3948feec4c4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-bdc0-74ae-a3b3-3948feec4c4e",
        "storage_key": "property/6767906449166460/019d02ce-bdc0-74ae-a3b3-3948feec4c4e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.westjordan.utah.gov/parks-department/reservations/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13516730981404283112&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "veterans-memorial-park",
      "poi_latitude": "40.6075",
      "poi_longitude": "-111.9444444",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-569-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d95e-77ba-86af-4ac3adc35bf8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d95e-77ba-86af-4ac3adc35bf8",
        "storage_key": "property/6767906449166460/019d02ce-d95e-77ba-86af-4ac3adc35bf8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTIV3imJUocR6JAefzYTlbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cd0386f9-6d6d-4a0e-a807-9bb0bf8955a8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Glenmoor Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9800 S 4800 W, South Jordan, UT 84095, USA",
      "poi_short_description": "Public, 18-hole course with a par-72 setup, plus a driving range and golf instructors.",
      "poi_long_description": "Golfers say this golf course offers a driving range, well-maintained greens, and a challenging course that's in good shape. They also highlight the friendly staff and the quick pace of play.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-befa-73e0-8467-71d544bdbef4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-befa-73e0-8467-71d544bdbef4",
        "storage_key": "property/6767906449166460/019d02ce-befa-73e0-8467-71d544bdbef4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://golfglenmoor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7843901902771641297&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glenmoor-golf-club",
      "poi_latitude": "40.57180109999999",
      "poi_longitude": "-112.0050634",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 801-280-1742",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-ddbd-77ec-8ca6-f7ce85e21ca8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-ddbd-77ec-8ca6-f7ce85e21ca8",
        "storage_key": "property/6767906449166460/019d02ce-ddbd-77ec-8ca6-f7ce85e21ca8.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJw9Vdy5-PUocR0du2xzgj22w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_3860dcf5-38e6-481a-a973-d9d78eb471d8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "South Jordan",
      "poi_type": "Transportation & Transit",
      "poi_address": "South Jordan, UT 84095, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-c0d4-72f0-9793-384ae59a102d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-c0d4-72f0-9793-384ae59a102d",
        "storage_key": "property/6767906449166460/019d02ce-c0d4-72f0-9793-384ae59a102d.webp",
        "width": 1280,
        "height": 780
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17633874443866309559&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "south-jordan",
      "poi_latitude": "40.5633978",
      "poi_longitude": "-111.9007251",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-dde5-727f-82b5-f275f8fc6c4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-dde5-727f-82b5-f275f8fc6c4c",
        "storage_key": "property/6767906449166460/019d02ce-dde5-727f-82b5-f275f8fc6c4c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJYWqZb8yHUocRt4N94GAbuPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_44803873-4519-499e-b593-94c871d3686f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Murray Central Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Murray, UT 84107, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-c269-772e-8927-7e01fc5cee1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-c269-772e-8927-7e01fc5cee1a",
        "storage_key": "property/6767906449166460/019d02ce-c269-772e-8927-7e01fc5cee1a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4812353299835600484&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "murray-central-station",
      "poi_latitude": "40.659983",
      "poi_longitude": "-111.8963567",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-dde5-727f-82b5-f275f8fc6c4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-dde5-727f-82b5-f275f8fc6c4c",
        "storage_key": "property/6767906449166460/019d02ce-dde5-727f-82b5-f275f8fc6c4c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJXT_qMSmKUocRZD5hStTpyEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_b4e0694d-99c6-46c9-b5f9-dab164c7b236",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Midvale Fort Union Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "7250 S 180 W, Midvale, UT 84047, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-c49c-7059-9c3a-37aabab5d5cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-c49c-7059-9c3a-37aabab5d5cf",
        "storage_key": "property/6767906449166460/019d02ce-c49c-7059-9c3a-37aabab5d5cf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.rideuta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1996623306778567443&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "midvale-fort-union-station",
      "poi_latitude": "40.6193196",
      "poi_longitude": "-111.8983943",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk8iOdqyJUocRE2PNplFutRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_97627838-3a20-40b4-bf62-ad8a3a2c67b4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "TRAX Historic Sandy Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "9000 S 165 E, Sandy, UT 84070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-c599-76cf-aeb9-3c47f5931ef5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-c599-76cf-aeb9-3c47f5931ef5",
        "storage_key": "property/6767906449166460/019d02ce-c599-76cf-aeb9-3c47f5931ef5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.rideuta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18044632952926587338&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trax-historic-sandy-station",
      "poi_latitude": "40.5892716",
      "poi_longitude": "-111.885732",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 801-743-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG40v9m2IUocRykl_7RBqa_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_3494a7b4-78db-4fba-a752-804e106c2252",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Daybreak Parkway Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "South Jordan, UT 84009, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-c745-728d-8e8d-5490feb46bf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-c745-728d-8e8d-5490feb46bf2",
        "storage_key": "property/6767906449166460/019d02ce-c745-728d-8e8d-5490feb46bf2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=733309488350824391&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daybreak-parkway-station",
      "poi_latitude": "40.54387639999999",
      "poi_longitude": "-112.0139869",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ7XVlm-FUocRxweTKxg9LQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_c37a418d-6ee0-4fdf-a050-d1397238d603",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "CHG Healthcare",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7259 Bingham Jct Blvd, Midvale, UT 84047, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-c84e-7153-b291-53891669f191.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-c84e-7153-b291-53891669f191",
        "storage_key": "property/6767906449166460/019d02ce-c84e-7153-b291-53891669f191.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://chghealthcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11715266888374622087&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chg-healthcare",
      "poi_latitude": "40.6193817",
      "poi_longitude": "-111.9145601",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-466-0637",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvfOb5QSJUocRhxd3Mir9lKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_581e6e43-d63d-4cc8-81c4-3228e41cdbb7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Zions Bancorporation’s Midvale Technology Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7860 Bingham Jct Blvd, Midvale, UT 84047, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-cb22-7499-9dc6-213a3fd70c3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-cb22-7499-9dc6-213a3fd70c3f",
        "storage_key": "property/6767906449166460/019d02ce-cb22-7499-9dc6-213a3fd70c3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.zionsbank.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14085986470835427343&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "zions-bancorporations-midvale-technology-center",
      "poi_latitude": "40.6076447",
      "poi_longitude": "-111.9182362",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-844-6080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7_0lfSGJUocRD5gagRB6e8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a0d06d44-255c-4cf3-ba40-bdb66b9e01fd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Morgan Stanley",
      "poi_type": "Major Employers & Offices",
      "poi_address": "680 W 10000 S, South Jordan, UT 84095, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-cc38-708e-b25a-86734a10aa87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-cc38-708e-b25a-86734a10aa87",
        "storage_key": "property/6767906449166460/019d02ce-cc38-708e-b25a-86734a10aa87.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11993714839462362970&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "morgan-stanley",
      "poi_latitude": "40.5713171",
      "poi_longitude": "-111.9097292",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 888-454-0555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKzuc8iuGUocRWj983xk8cqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1e8ed2ee-2b35-44fe-b97e-7d4d4268a002",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "NICE CXone",
      "poi_type": "Major Employers & Offices",
      "poi_address": "75 W Towne Ridge Pkwy, Sandy, UT 84070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-cdf7-733f-a5a4-6f35290cd02c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-cdf7-733f-a5a4-6f35290cd02c",
        "storage_key": "property/6767906449166460/019d02ce-cdf7-733f-a5a4-6f35290cd02c.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.niceincontact.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16203302297593927125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nice-cxone",
      "poi_latitude": "40.5754182",
      "poi_longitude": "-111.8919942",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 801-320-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl-1Mxp1iUocR1VVbRJex3eA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f09f9939-16ea-4e8e-bbec-7595d6c80ec5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Cricut, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10855 S River Front Pkwy #300, South Jordan, UT 84095, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-ce8a-7461-af0f-f5047744d0ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-ce8a-7461-af0f-f5047744d0ee",
        "storage_key": "property/6767906449166460/019d02ce-ce8a-7461-af0f-f5047744d0ee.webp",
        "width": 790,
        "height": 768
      },
      "poi_business_url": "https://cricut.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3526089701309332585&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cricut-inc",
      "poi_latitude": "40.5537271",
      "poi_longitude": "-111.9124191",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 877-727-4288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo0c23jeGUocRaby0vOYv7zA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_3cb0bd6e-55f0-4141-ad3c-a158d9c2f7b0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Oquirrh Elementary School",
      "poi_type": "Education",
      "poi_address": "7165 S 3285 W, West Jordan, UT 84084, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f01be-d5f3-76bb-8067-7bb0474316c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01be-d5f3-76bb-8067-7bb0474316c4",
        "storage_key": "property/6767906449166460/019f01be-d5f3-76bb-8067-7bb0474316c4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oquirrh.jordandistrict.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1646366968784751381&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oquirrh-elementary-school",
      "poi_latitude": "40.6212192",
      "poi_longitude": "-111.9689469",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-565-7474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d426-72f3-8873-f21dd6a76ae9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d426-72f3-8873-f21dd6a76ae9",
        "storage_key": "property/6767906449166460/019d02ce-d426-72f3-8873-f21dd6a76ae9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU-scXMeOUocRFQtaCAkS2RY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_798af27d-cbb1-4854-b29a-259dc85aece3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Joel P. Jensen Middle School",
      "poi_type": "Education",
      "poi_address": "8105 3200 W, West Jordan, UT 84088, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f01be-d56a-73de-afa0-39faee168e38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01be-d56a-73de-afa0-39faee168e38",
        "storage_key": "property/6767906449166460/019f01be-d56a-73de-afa0-39faee168e38.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://joelpjensen.jordandistrict.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4836151958652022726&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "joel-p-jensen-middle-school",
      "poi_latitude": "40.6042322",
      "poi_longitude": "-111.9660358",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-412-2850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d426-72f3-8873-f21dd6a76ae9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d426-72f3-8873-f21dd6a76ae9",
        "storage_key": "property/6767906449166460/019d02ce-d426-72f3-8873-f21dd6a76ae9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZcpUFdiOUocRxm9DV5V2HUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_33ae6706-a1ba-409f-a1e2-f8383fe3fae6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "West Jordan High School",
      "poi_type": "Education",
      "poi_address": "8136 2700 W, West Jordan, UT 84088, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f01be-d52a-712c-8d69-173f6205026a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01be-d52a-712c-8d69-173f6205026a",
        "storage_key": "property/6767906449166460/019f01be-d52a-712c-8d69-173f6205026a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://westjordanhigh.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9765296496659509784&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "west-jordan-high-school",
      "poi_latitude": "40.603753",
      "poi_longitude": "-111.9593288",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-256-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d426-72f3-8873-f21dd6a76ae9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d426-72f3-8873-f21dd6a76ae9",
        "storage_key": "property/6767906449166460/019d02ce-d426-72f3-8873-f21dd6a76ae9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf3ecK9aOUocRGLLByWxNhYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_3dde9c78-eca6-48a2-a93d-0255adea353a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Viridian Event Center",
      "poi_type": "Education",
      "poi_address": "8030 S 1825 W, West Jordan, UT 84088, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this event center offers a beautiful, spacious, and inclusive venue for various events, including concerts and community gatherings. Visitors also highlight the spotless facilities, including clean restrooms, and the convenient, ample parking. Guests mention the staff are amazing, helpful, and knowledgeable, ensuring smooth event coordination.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f01be-d964-70d5-917e-2bc37f9d7b17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01be-d964-70d5-917e-2bc37f9d7b17",
        "storage_key": "property/6767906449166460/019f01be-d964-70d5-917e-2bc37f9d7b17.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.slcolibrary.org/locations/viridian",
      "poi_directions_map_url": "https://maps.google.com/?cid=9929803399595093728&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "viridian-event-center",
      "poi_latitude": "40.6051864",
      "poi_longitude": "-111.9428728",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-943-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhaTceACJUocR4O5U4pS_zYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_dead883b-206c-4a83-9cc5-6d4967f5f404",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Bingham Junction TRAX Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Midvale, UT 84047, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f01be-d9c5-741d-b137-53b29164a282.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01be-d9c5-741d-b137-53b29164a282",
        "storage_key": "property/6767906449166460/019f01be-d9c5-741d-b137-53b29164a282.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4810856812092235314&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bingham-junction-trax-station",
      "poi_latitude": "40.6170671",
      "poi_longitude": "-111.9156445",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOzZ3UAOJUocRMp4GFsiYw0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_8f73ee8b-39fe-4e4b-bb58-71acbc1b74df",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Mountain America Credit Union - West Jordan: 7800 South Branch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3782 W 7800 S, West Jordan, UT 84084, USA",
      "poi_short_description": "Financial institution offering checking and savings accounts, auto loans, and personal finance consulting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f01be-d567-725e-84e1-e8e1d476677c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01be-d567-725e-84e1-e8e1d476677c",
        "storage_key": "property/6767906449166460/019f01be-d567-725e-84e1-e8e1d476677c.webp",
        "width": 510,
        "height": 287
      },
      "poi_business_url": "https://www.macu.com/branch-locations/utah/salt-lake-county/west-jordan-jordan-landing-branch?cid=ea-gmb-website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=9574035130571597256&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mountain-america-credit-union---west-jordan-7800-south-branch",
      "poi_latitude": "40.6099883",
      "poi_longitude": "-111.9809869",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-280-1525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS_amvOiOUocRyKXU0DnO3YQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "custom_99aa5afd-2b91-4cd4-9c54-b4bdd3bbcf66",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "Ron Wood Regional Park Splash Pad",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6000 W New Bingham Hwy, West Jordan, UT 84081, USA",
      "poi_short_description": "Family-friendly park featuring a splash pad, playground and basketball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f0271-47d8-70e5-a7be-c3dc9b5aca88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0271-47d8-70e5-a7be-c3dc9b5aca88",
        "storage_key": "property/6767906449166460/019f0271-47d8-70e5-a7be-c3dc9b5aca88.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://westjordan.utah.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13139046825929216990&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ron-wood-regional-park-splash-pad",
      "poi_latitude": "40.5931886",
      "poi_longitude": "-112.0359285",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d912-763c-8bdf-6514615e25f8",
        "storage_key": "property/6767906449166460/019d02ce-d912-763c-8bdf-6514615e25f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCR_1u7yPUocR3hO8enlFV7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_34dd2189-e942-4b12-8398-6d3341f65b6f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "poi_name": "ABC Great Beginnings - Jordan Landing",
      "poi_type": "Education",
      "poi_address": "7172 Center Park Dr, West Jordan, UT 84084, USA",
      "poi_short_description": "Long-running chain providing day care and early education to children in a vibrant setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f061b-ab5e-7244-9b54-9acd625e12cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f061b-ab5e-7244-9b54-9acd625e12cc",
        "storage_key": "property/6767906449166460/019f061b-ab5e-7244-9b54-9acd625e12cc.webp",
        "width": 1080,
        "height": 720
      },
      "poi_business_url": "https://abcgreatbeginnings.com/locations/jordan-landing?utm_source=googleMyBusiness&utm_medium=organic&utm_campaign=directory_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=15965391399859685982&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "abc-great-beginnings---jordan-landing",
      "poi_latitude": "40.621064",
      "poi_longitude": "-111.986196",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 801-280-9222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-d426-72f3-8873-f21dd6a76ae9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-d426-72f3-8873-f21dd6a76ae9",
        "storage_key": "property/6767906449166460/019d02ce-d426-72f3-8873-f21dd6a76ae9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv1p_-JKOUocRXoq20ON2kN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    }
  ],
  "office_hours": [
    {
      "id": "ec_33ea6cf1fe1fac2729ff4354",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f45e7ecf23a12d912f3716d9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a46cbf5c48f73003c93defed",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d7d0c31e28c0e6a34d884633",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9e3b24cdf8be06d17e883279",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_da46f720949a1e06dc2c360e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_ffe558f2-b245-4889-a923-bfc08c0d6902",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "rating": "5.0",
      "name": "emma milner",
      "text": "I love wood gate! me and my roommates have been here a few months now and it has been awesome. The place is nice, cute and well kept, the staff are always on it and get whatever you need done with speed and the community is great, we have some really nice neighbors who welcomed us into the community kindly. My biggest worry with an apartment was the size, we didn’t want everything into be tiny for a high price, but the apartment here are so spacious and aren’t astronomically expensive. awesome place🙏",
      "date": "2025-09-26",
      "title": ""
    },
    {
      "id": "custom_252a90e6-485a-415f-b911-1ee166f8dbc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "rating": "5.0",
      "name": "Kelli Redding",
      "text": "We recently moved here and love it so much. The yards and shared spaces are kept clean. Moving in you could tell the apartments are well kept. And the few maintenance needs we have had so far have been met immediately and well.\n\nIt’s a nice complex and we are happy to call it home.\n\n-Kelli Berryhill",
      "date": "2025-09-26",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_48d5bfbb-bc1f-4ded-abc0-f11c6352e3c9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f6c19-756e-7105-aa6d-00b3fff7a431.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c19-756e-7105-aa6d-00b3fff7a431",
        "storage_key": "property/6767906449166460/019f6c19-756e-7105-aa6d-00b3fff7a431.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 860 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=keqQetdaMmn"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199dff5-55c6-74c8-bff7-de000282777b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-woodgate",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "generator",
      "page_item_url": "apartments-with-pool-west-jordan-ut",
      "search_query": "apartments with pool in West Jordan UT",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in West Jordan, UT",
      "h2_subtitle": "Experience ultimate relaxation at Woodgate. Our West Jordan UT community offers a serene swimming pool perfect for unwinding and socializing.",
      "page_copy": "Discover Woodgate, where our residents enjoy access to luxurious amenities, including a refreshing swimming pool, perfect for those sunny West Jordan days. Whether you're looking to take a dip or lounge poolside with a good book, our beautiful community pool meets all your relaxation and socializing needs. \n\nLocated in scenic West Jordan, UT, our community is the perfect blend of style and comfort. Woodgate's beautifully renovated apartments offer the ultimate living experience with access to this remarkable pool, a state-of-the-art open-air spa, and a modern fitness center. Elevate your lifestyle and make a splash in West Jordan today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with mountains in the background.",
        "public_id": "019d02ce-1e1b-77ea-844b-e1a8db1789ca",
        "storage_key": "property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in West Jordan, UT",
      "seo_description": "Enjoy the serenity of a swimming pool and modern amenities at Woodgate, your ideal West Jordan UT apartment destination.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-salt-lake-county",
      "search_query": "in-unit laundry apartments Salt Lake County",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Salt Lake County",
      "h2_subtitle": "Woodgate offers the convenience of in-unit laundry. Enjoy sophisticated living with this essential amenity in Salt Lake County.",
      "page_copy": "At Woodgate in West Jordan, UT, residents experience a blend of convenience and luxury. Our stylish apartments come equipped with in-unit laundry facilities, ensuring that residents enjoy the maximum convenience of doing laundry at home. This desirable feature is complemented by our modern kitchen amenities and spacious interiors.\n\nLocated within the vibrant community of West Jordan in Salt Lake County, Woodgate offers a host of amenities such as a year-round open-air spa and a state-of-the-art fitness center. Our community is designed to make life easier and more enjoyable, allowing you to focus on what truly matters. Discover the comfort of in-unit laundry apartments near you today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with mountains in the background.",
        "public_id": "019d02ce-1e1b-77ea-844b-e1a8db1789ca",
        "storage_key": "property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Salt Lake County",
      "seo_description": "Experience the convenience of in-unit laundry at Woodgate, ideally located in Salt Lake County with modern living amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "generator",
      "page_item_url": "dog-park-apartments-dixie-valley",
      "search_query": "dog park apartments in Dixie Valley",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Dixie Valley",
      "h2_subtitle": "Enjoy pet-friendly living at Woodgate. Our Dixie Valley location offers easy access to nearby dog parks, perfect for your furry friends.",
      "page_copy": "Welcome to Woodgate, where pet-friendly living is our priority. Located in the charming Dixie Valley neighborhood, we ensure both you and your furry friends feel at home. Although our community doesn’t feature an on-site dog park, we are conveniently situated near various parks in West Jordan, providing ample opportunities for outdoor adventures with your pet.\n\nNestled in the heart of Dixie Valley, West Jordan, our renovated apartments boast spectacular amenities, including open-air spa facilities and a fully-equipped fitness center. Embrace the convenience and ease of pet-friendly living at Woodgate, where both you and your four-legged companion can thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with mountains in the background.",
        "public_id": "019d02ce-1e1b-77ea-844b-e1a8db1789ca",
        "storage_key": "property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Dixie Valley",
      "seo_description": "Live near dog parks in Dixie Valley at Woodgate, where pet-friendly amenities meet modern comfort in West Jordan.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "generator",
      "page_item_url": "dishwasher-equipped-apartments-84084",
      "search_query": "dishwasher equipped apartments 84084",
      "category": "Amenity",
      "h1_title": "Dishwasher Equipped Apartments in 84084",
      "h2_subtitle": "Enjoy convenience at Woodgate, where each apartment in the 84084 area comes equipped with modern dishwashers and luxurious features.",
      "page_copy": "Located in the heart of West Jordan, UT, Woodgate offers beautifully renovated apartments that enhance daily living with amenities like in-unit dishwashers. In the 84084 area, our community is designed to cater to modern lifestyles, providing ease and efficiency in home chores so you can focus on enjoying life’s finer things.\n\nBeyond the convenience of a dishwasher, Woodgate boasts other top-tier amenities such as state-of-the-art fitness facilities, a relaxing open-air spa, and stunning views. Experience the warmth and comfort of a home that meets your everyday needs with style and grace in Salt Lake County's vibrant neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with mountains in the background.",
        "public_id": "019d02ce-1e1b-77ea-844b-e1a8db1789ca",
        "storage_key": "property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Equipped Apartments in 84084",
      "seo_description": "Discover Woodgate in West Jordan, UT 84084, where each apartment features a modern dishwasher plus luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-south-cobble-ridge-drive",
      "search_query": "air conditioned apartments near South Cobble Ridge Drive",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near Cobble Ridge",
      "h2_subtitle": "Stay cool at Woodgate with our air-conditioned apartments. Located near South Cobble Ridge Drive, enjoy comfort and luxury living.",
      "page_copy": "Experience refreshing comfort at Woodgate, where each apartment is fully air-conditioned to provide a perfect escape from the warm seasons. Strategically located near South Cobble Ridge Drive in West Jordan, our residences offer an ideal blend of comfort, convenience, and style.\n\nOur community features elegantly renovated apartments, complete with modern amenities, ensuring a luxurious living experience. Enjoy access to our fitness center and serene swimming pool, all designed to complement the comfort of your air-conditioned home. Live in ease and elegance in Salt Lake County’s sought-after neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with mountains in the background.",
        "public_id": "019d02ce-1e1b-77ea-844b-e1a8db1789ca",
        "storage_key": "property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near Cobble Ridge",
      "seo_description": "Enjoy comfort at Woodgate, with air-conditioned apartments near South Cobble Ridge Drive offering style and convenience in West Jordan.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-west-jordan-ut",
      "search_query": "1 bedroom apartments west jordan ut",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in West Jordan, UT",
      "h2_subtitle": "Discover cozy 1 bedroom apartments at Woodgate in West Jordan, UT. Enjoy modern amenities and a vibrant community atmosphere.",
      "page_copy": "At Woodgate in West Jordan, UT, find the perfect one-bedroom apartment designed for comfort and modern living. Each unit is elegantly renovated, offering a contemporary style with amenities like hardwood floors and a convenient dining room, all nestled in the heart of a vibrant community.\n\nBeyond the cozy interiors, Woodgate enhances your lifestyle with fantastic community features. Take advantage of our state-of-the-art fitness center and unwind in the year-round open-air spa. Enjoy the serene surroundings and make yourself at home in Salt Lake County’s thriving neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with mountains in the background.",
        "public_id": "019d02ce-1e1b-77ea-844b-e1a8db1789ca",
        "storage_key": "property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in West Jordan, UT",
      "seo_description": "Explore Woodgate’s cozy one-bedroom apartments in West Jordan, UT. Modern amenities and a vibrant community await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-salt-lake-county",
      "search_query": "2 bedroom apartments salt lake county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Salt Lake County",
      "h2_subtitle": "Discover spacious 2 bedroom apartments at Woodgate, located in Salt Lake County. Enjoy modern amenities and a welcoming community.",
      "page_copy": "Woodgate in West Jordan offers spacious two-bedroom apartments that are perfect for those seeking comfort and convenience in Salt Lake County. Each apartment is thoughtfully designed with modern touches, featuring hardwood floors, ample storage in linen closets, and a cozy dining area.\n\nBeyond the beautifully renovated interiors, residents can indulge in exceptional amenities, including a serene swimming pool and a fully-equipped fitness center. Nestled in the heart of Dixie Valley, Woodgate's community provides an inviting atmosphere, making it an ideal home base in Salt Lake County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with mountains in the background.",
        "public_id": "019d02ce-1e1b-77ea-844b-e1a8db1789ca",
        "storage_key": "property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Salt Lake County",
      "seo_description": "Explore spacious 2 bedroom apartments at Woodgate in Salt Lake County, featuring modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-84084",
      "search_query": "3 bedroom apartments near 84084",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 84084",
      "h2_subtitle": "Find expansive 3 bedroom apartments at Woodgate near the 84084 area. Enjoy modern living with plenty of amenities.",
      "page_copy": "Discover the spaciousness and comfort of our three-bedroom apartments at Woodgate, conveniently located near the 84084 area in West Jordan. Each unit is beautifully renovated, featuring modern interiors designed for both style and functionality, with hardwood floors and accommodating dining spaces.\n\nIn addition to our roomy apartments, Woodgate offers a variety of amenities that elevate daily living. Residents can unwind in our year-round open-air spa, keep fit in the state-of-the-art fitness center, or relax by the serene swimming pool. Experience a vibrant lifestyle in Salt Lake County's picturesque neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with mountains in the background.",
        "public_id": "019d02ce-1e1b-77ea-844b-e1a8db1789ca",
        "storage_key": "property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 84084",
      "seo_description": "Explore spacious 3 bedroom apartments at Woodgate near the 84084 area. Modern living with abundant amenities awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "generator",
      "page_item_url": "apartments-near-salt-lake-community-college",
      "search_query": "apartments near salt lake community college taylorsville",
      "category": "School",
      "h1_title": "Apartments Near Salt Lake Community College",
      "h2_subtitle": "Discover modern apartments at Woodgate, conveniently located near Salt Lake Community College Taylorsville.",
      "page_copy": "Woodgate in West Jordan offers ideal apartment living just a short drive from Salt Lake Community College's Taylorsville campus. Our community provides beautifully renovated apartments that blend contemporary finishes with everyday comforts, making it an excellent choice for students and professionals alike.\n\nResidents of Woodgate can enjoy a wealth of amenities designed for relaxation and convenience. With an open-air spa, state-of-the-art fitness center, and serene swimming pool, living near SLCC Taylorsville has never been more appealing. Discover the perfect harmony of comfort and proximity at Woodgate.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with mountains in the background.",
        "public_id": "019d02ce-1e1b-77ea-844b-e1a8db1789ca",
        "storage_key": "property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Salt Lake Community College",
      "seo_description": "Find modern apartments at Woodgate near SLCC Taylorsville. Enjoy amenities and convenient living close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "generator",
      "page_item_url": "woodgate-apartments-close-to-slcc-jordan-campus",
      "search_query": "woodgate apartments close to slcc jordan campus utah",
      "category": "School",
      "h1_title": "Woodgate Apartments Near SLCC Jordan",
      "h2_subtitle": "Explore Woodgate Apartments, located conveniently close to the SLCC Jordan Campus in Utah. Ideal for students and professionals alike.",
      "page_copy": "Experience comfort and convenience at Woodgate Apartments, ideally situated near the SLCC Jordan Campus in Utah. Our apartments offer a variety of floor plans, including one, two, and three-bedroom options that blend modern design with practical living. Enjoy hardwood floors, ample storage with linen closets, and inviting dining areas.\n\nWoodgate is perfect for those balancing education and leisure, providing amenities like a state-of-the-art fitness center, a tranquil swimming pool, and a relaxing year-round spa. With its proximity to the Jordan Campus, Woodgate offers the ideal environment for students seeking convenience and a welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with mountains in the background.",
        "public_id": "019d02ce-1e1b-77ea-844b-e1a8db1789ca",
        "storage_key": "property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Woodgate Apartments Near SLCC Jordan Campus",
      "seo_description": "Woodgate Apartments offer modern living near SLCC Jordan Campus, featuring spacious designs and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "generator",
      "page_item_url": "apartments-near-commonspirit-holy-cross-hospital",
      "search_query": "apartments near CommonSpirit Holy Cross Hospital West Jordan",
      "category": "Hospital",
      "h1_title": "Apartments Near Holy Cross Hospital",
      "h2_subtitle": "Discover comfortable living at Woodgate, just moments from CommonSpirit Holy Cross Hospital in West Jordan.",
      "page_copy": "Woodgate Apartments in West Jordan offers the perfect living environment, located conveniently close to CommonSpirit Holy Cross Hospital. Our community features beautifully updated apartments that provide modern comforts such as hardwood floors and spacious dining areas, perfect for both professionals and families.\n\nBeyond the stunning interiors, Woodgate provides residents with a suite of amenities aimed at enhancing relaxation and lifestyle. Unwind at our open-air spa, get an invigorating workout at the fitness center, or enjoy leisurely swims in our serene pool. With its strategic location near the hospital, Woodgate Apartments ensures a balanced lifestyle of convenience and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with mountains in the background.",
        "public_id": "019d02ce-1e1b-77ea-844b-e1a8db1789ca",
        "storage_key": "property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Holy Cross Hospital",
      "seo_description": "Find modern apartments at Woodgate near Holy Cross Hospital in West Jordan, offering top-tier amenities and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "generator",
      "page_item_url": "apartments-close-to-intermountain-health-tosh-campus",
      "search_query": "apartments close to Intermountain Health TOSH Campus Salt Lake County",
      "category": "Hospital",
      "h1_title": "Apartments Near Intermountain TOSH Campus",
      "h2_subtitle": "Explore Woodgate Apartments, situated conveniently near the Intermountain Health TOSH Campus in Salt Lake County.",
      "page_copy": "Woodgate Apartments in West Jordan are ideally located for those needing easy access to the Intermountain Health TOSH Campus. Experience the luxury of beautifully renovated one, two, or three-bedroom apartments that come with chic hardwood floors and ample storage options like linen closets.\n\nEnjoy the benefits of community amenities designed for both relaxation and activity, such as our open-air spa and modern fitness center. If you're working, studying, or receiving care in the TOSH Campus area, Woodgate Apartments provide a balanced fusion of convenient access and peaceful living in Salt Lake County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with mountains in the background.",
        "public_id": "019d02ce-1e1b-77ea-844b-e1a8db1789ca",
        "storage_key": "property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Intermountain TOSH Campus",
      "seo_description": "Discover Woodgate, apartments near Intermountain TOSH Campus. Enjoy modern amenities and convenient Salt Lake County location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "generator",
      "page_item_url": "apartments-near-murray-park-west-jordan",
      "search_query": "apartments near Murray Park West Jordan",
      "category": "Park",
      "h1_title": "Apartments Near Murray Park West Jordan",
      "h2_subtitle": "Find Woodgate Apartments, conveniently located near Murray Park in West Jordan. Enjoy modern living with plenty of nearby recreation.",
      "page_copy": "Discover the charm of Woodgate Apartments, ideally located near the picturesque Murray Park in West Jordan. Our community offers a perfect blend of style and functionality, featuring renovated one, two, and three-bedroom layouts adorned with hardwood floors and spacious dining areas.\n\nResidents at Woodgate can relish in a host of amenities including a year-round open-air spa and a comprehensive fitness center, ideal for enhancing your lifestyle. Proximity to Murray Park means you're just a short distance from beautiful landscapes and recreational opportunities, making it easy to enjoy both urban conveniences and outdoor leisure.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with mountains in the background.",
        "public_id": "019d02ce-1e1b-77ea-844b-e1a8db1789ca",
        "storage_key": "property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Murray Park West Jordan",
      "seo_description": "Discover modern living at Woodgate, near Murray Park in West Jordan. Enjoy stylish apartments with top amenities and nearby outdoor activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "generator",
      "page_item_url": "homes-close-to-veterans-memorial-park-ut",
      "search_query": "homes close to Veterans Memorial Park UT",
      "category": "Park",
      "h1_title": "Homes Near Veterans Memorial Park UT",
      "h2_subtitle": "Explore Woodgate, offering homes conveniently close to Veterans Memorial Park in Utah. Enjoy a serene and well-connected lifestyle.",
      "page_copy": "Woodgate Apartments in West Jordan offer the perfect homes for those looking to be close to Veterans Memorial Park. Our community presents a selection of beautifully updated living spaces, including one, two, and three-bedroom apartments that feature sleek hardwood floors and thoughtfully designed living areas.\n\nResidents enjoy access to a variety of amenities such as a year-round open-air spa, fitness center, and a refreshing swimming pool. The nearby Veterans Memorial Park provides an ideal spot for outdoor activities and relaxation, ensuring that Woodgate residents enjoy a balanced lifestyle combining tranquility, convenience, and modern comforts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with mountains in the background.",
        "public_id": "019d02ce-1e1b-77ea-844b-e1a8db1789ca",
        "storage_key": "property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Homes Near Veterans Memorial Park UT",
      "seo_description": "Find homes at Woodgate, close to Veterans Memorial Park UT. Enjoy modern amenities and scenic views in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "generator",
      "page_item_url": "apartments-near-midvale-fort-union-station",
      "search_query": "apartments near Midvale Fort Union Station West Jordan",
      "category": "Transit",
      "h1_title": "Apartments Near Midvale Fort Union Station",
      "h2_subtitle": "Discover Woodgate Apartments, ideally located near Midvale Fort Union Station in West Jordan for convenient commuting and urban living.",
      "page_copy": "Woodgate Apartments is your gateway to convenient living, perfectly situated near Midvale Fort Union Station in West Jordan. Choose from our selection of stylish one, two, and three-bedroom apartments, boasting features like elegant hardwood flooring and ample storage space including linen closets.\n\nResidents at Woodgate enjoy an array of amenities, including a state-of-the-art fitness center, a serene open-air spa, and a tranquil swimming pool. Located near Midvale Fort Union Station, our community offers the ease of commuting and quick access to various urban attractions, enhancing your lifestyle with both convenience and modern comforts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with mountains in the background.",
        "public_id": "019d02ce-1e1b-77ea-844b-e1a8db1789ca",
        "storage_key": "property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Midvale Fort Union Station",
      "seo_description": "Discover Woodgate Apartments near Midvale Fort Union Station, offering modern amenities and convenient access in West Jordan.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "generator",
      "page_item_url": "woodgate-close-to-trax-historic-sandy-station",
      "search_query": "Woodgate apartments close to TRAX Historic Sandy Station",
      "category": "Transit",
      "h1_title": "Woodgate Apartments Near TRAX Sandy",
      "h2_subtitle": "Live at Woodgate, just a short distance from the TRAX Historic Sandy Station. Enjoy seamless transit in a comfortable setting.",
      "page_copy": "At Woodgate Apartments, you'll enjoy a lifestyle that combines modern convenience with excellent connectivity, being located close to TRAX Historic Sandy Station. Our apartment community offers a variety of floor plans, including one, two, and three-bedroom options, all enhanced with modern finishes like hardwood floors and spacious dining areas.\n\nExperience a range of amenities designed to complement your lifestyle. Whether you prefer a workout in our fitness center or a relaxing dip in the pool, Woodgate has it all. With TRAX Historic Sandy Station nearby, residents can commute with ease, enjoying quick access to work and entertainment while coming home to a peaceful, well-appointed living space.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with mountains in the background.",
        "public_id": "019d02ce-1e1b-77ea-844b-e1a8db1789ca",
        "storage_key": "property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Woodgate Apartments Near TRAX Sandy",
      "seo_description": "Find Woodgate Apartments near TRAX Historic Sandy Station, blending modern living with convenient transport access in West Jordan.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166460",
      "source": "generator",
      "page_item_url": "west-jordan-rentals-near-daybreak-parkway-station",
      "search_query": "West Jordan rentals by Daybreak Parkway Station",
      "category": "Transit",
      "h1_title": "West Jordan Rentals by Daybreak Parkway",
      "h2_subtitle": "Discover the perfect rentals at Woodgate, ideally located near Daybreak Parkway Station in West Jordan, UT. Enjoy seamless transit and comfort.",
      "page_copy": "Woodgate offers exceptional rental opportunities in West Jordan, conveniently located near Daybreak Parkway Station. Our community features spacious one, two, and three-bedroom apartment layouts that cater to a variety of lifestyle needs. Each apartment comes equipped with modern enhancements, including elegant hardwood floors and ample storage solutions like linen closets.\n\nBeyond the comfort of home, residents appreciate amenities such as a state-of-the-art fitness center, a soothing open-air spa, and a sparkling pool. Living near Daybreak Parkway Station, Woodgate residents enjoy the advantages of easy commuting and access to the greater Salt Lake area, making it the ideal choice for those seeking both convenience and a well-rounded living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with mountains in the background.",
        "public_id": "019d02ce-1e1b-77ea-844b-e1a8db1789ca",
        "storage_key": "property/6767906449166460/019d02ce-1e1b-77ea-844b-e1a8db1789ca.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "West Jordan Rentals Near Daybreak Parkway",
      "seo_description": "Explore West Jordan rentals at Woodgate, located near Daybreak Parkway Station offering modern amenities and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5333"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425009"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=0a37166105fbaa5749ffd407e42ba4365049e31008ca39461b343c75be2830fe3accb1daaf5ea7b2988c08fb7386a550\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T5PVZXC8"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "628WJL"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40256880237"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "11066609-DB00"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://mktapts.s3.us-west-2.amazonaws.com/images/bascom/628WJL/video/2025/woodgate.mp4"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Woodgate/scheduletourwidget/6oZaMy5sxDayIPZ41j/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkgzZEcxdTJNU3h0dTRoL0NNVzRZYnc9PSIsInZhbHVlIjoibmV2R2tHUGM5R2ViNk9EalJUT0djdz09IiwibWFjIjoiZjBjYTYzMjY1NTY4YzZiNDZiMzIwMTIzN2I2Mzc4MTVlODAxOTBjMDZhZmE0NmQyYmIyODE1MWJmN2I3YzMyNCJ9"
    }
  ],
  "custom_qb_id": "5333",
  "custom_repli_id": "18104425009",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=0a37166105fbaa5749ffd407e42ba4365049e31008ca39461b343c75be2830fe3accb1daaf5ea7b2988c08fb7386a550\"></script>",
  "custom_google_gtm_id": "GTM-T5PVZXC8",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "628WJL",
  "custom_hubspot_company_id": "40256880237",
  "custom_broker_license_number": "11066609-DB00",
  "custom_property_featured_video": "https://mktapts.s3.us-west-2.amazonaws.com/images/bascom/628WJL/video/2025/woodgate.mp4",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Woodgate/scheduletourwidget/6oZaMy5sxDayIPZ41j/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkgzZEcxdTJNU3h0dTRoL0NNVzRZYnc9PSIsInZhbHVlIjoibmV2R2tHUGM5R2ViNk9EalJUT0djdz09IiwibWFjIjoiZjBjYTYzMjY1NTY4YzZiNDZiMzIwMTIzN2I2Mzc4MTVlODAxOTBjMDZhZmE0NmQyYmIyODE1MWJmN2I3YzMyNCJ9",
  "custom_audioeye_site_id": "b7ed0193-cbc0-45bb-bd2e-edd9b97b6737",
  "custom_audioeye_site_hash": "1e29f6ddda18ba7334fe944c19296860"
};

export const generatedAt = '2026-08-21T22:01:00.437Z';
